import React from "react";
import LayoutMensajesVirgen from "../components/LayoutMensajesVirgen";

export default function MensajesVirgenGer() {
  return (
    <>
      <LayoutMensajesVirgen>
        <div className="col-12 text-center">
          <h5>
            VERKÜNDUNGEN DER <br /> ALLERHEILIGSTEN JUNGFRAU
          </h5>
          <h5>13/7/ 1990 zum 01/04/2003</h5>
          <h5>Salta - Argentinien</h5>
        </div>

        <div className="col-12 mt-5">
          <h6>Salta: 30. Oktober 1997.</h6>
          <p>
            Nichts verhindert die Veröffentlichung <br />
            Priester Dante Bernacki-Zensor"
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Salta, 31. Oktober 1997.</h6>
          <p>
            Es ist erlaubt dies zu drucken für den privaten Gebrauch der
            Gläubigen. <br />
            Mons. Moises Julio Blanchoud - Erzbischof“. <br />
            Weihe dem Allerheiligsten Eucharistischem Herzen Jesu
          </p>
        </div>

        <div className="col-12 mt-5">
          <p>
            Allerheiligstes Eucharistisches Herz Jesu, ich vertraue unermesslich
            auf Dein Erbarmen. <br />
            Ich bitte Dich mit aller Bescheidenheit mir den Glauben zu geben um
            mich Deiner unendlichen Barmherzigkeit zu ergeben, denn es sind
            meine menschlichen Kräfte geschwunden und nun steht mir nur noch zu,
            mein Vetrauen Deinem unendlichen Erbarmen zuzuwenden, denn DU wirst
            mein Flehen nicht überhören. <br />
            Hier bin ich, Herr zu Deinen Füssen und bitte Dich innigstlich alle
            meine Sachen und Probleme zu ordnen, gemäss Deiner Liebe und
            himmlischer Fürsorge, da ich weiss dies wird das Beste für mich
            sein, lasse es zu, ich bitte Dich, wenn es für das Wohl meiner Seele
            ist. <br />
            ¡ Nimm Herr! Mein Problem <br />
            ¡Nimm mein Herz! <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu. <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu. <br />
            Amen <br />
            Weihe dem unbefleckten Herzen von Maria <br />
            “Reinste” Mutter mein, Dir möchte ich mein Herz weihen, meinen
            Willen mein ganzes Leben. <br />
            Bringe mich zum Herzen Deines Göttlichen Sohnes Jesu damit Er in mir
            weile. <br />
            Ich möchte völlig Dein sein Mutter mein und ab heute, Dir treu
            dienen in dem was Du mir beschiedst. <br />
            Sei süsse Begleitung in meinem Leben, und erlaube nie dass ich mich
            von Dir abweiche, In der Stunde meines Todes holemichum in der
            EwigkeitmichDeiner Gegenwart erfreuen zu können . <br />
            “Gesegnet und verehrt seist Du für immer Mutter mein”.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Juli 1990</h6>
          <p>
            Unsere<strong>Frau der Tränen,</strong>wird Dir verkünden was sie am
            16. von Dir möchte, Du möchtest viel für die Sünder, für die
            Besorgten und für die Leidenden beten . Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31. Juli 1990 (während des Gebets)</h6>
          <p>
            <strong>Die Unbefleckte Empfägnis</strong> sagte:” ich werde ein
            grosses Ereignis bereiten damit alle glauben.”
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11. August 1990</h6>
          <p>
            (nachdem ichmichdem Herrn geweiht hatte, öffnete die Allerheiligste
            Mutter ihre Arme lächelnd und mit viel Freude sagte sie mir). <br />
            “Komm meine Tochter, geehret sie der Herr, die Engel werden Dich
            begleiten, der Herr wird dir einen Weg mit Licht eröffnen”.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Donnerstag 16. August 1990</h6>
          <p>
            Maria. Du musst für den Frieden der Welt beten, er ist in Gefahr,
            für die Sünder, für die Leidenden und für die Besorgten. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Freitag den 17. August 1990</h6>
          <p>
            Die<strong>Frau der Tränen</strong>sendet mich Euch mitzuteielen:
            <br />
            “Bald werde ich bei Euch sein, ich möchte denen helfen die mich
            nötig haben, es gibt viele Kinder die wegen der drohenden Umstände
            leiden, ihnen werde ich meine Barmherzigkeit geben, ich benötige
            einen Ort wo auch mein gesegneter Sohn mit seiner Kirche ist.! Möge
            es bald sein, es gibt viele Armseligen”. Ich segne Euch Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31. August 1990</h6>
          <p>
            Meine Kinder: <br />
            Der Rosenkranz soll nicht als Glücksamulett getragen werden, mittels
            täglichen betens des Heiligen Rosenkranzes, flehen wir die göttliche
            Hilfe an und huldigen Gott. <br />
            Unserer lieben Jugend bitte ich dass sie ihre Augen zu Jesus wende,
            um die Welt von den Sünden zu retten in welche sie einbezogen ist.{" "}
            <br />
            Das tägliche Gebet einfach und bescheiden findet vor allem Gefallen
            in unserem Herrn. <br />
            Betet alle mit grosser Demut und Euch wird der Friede dem Geiste
            gegeben die Euch für den Herrn vorbereiten. Ich segne Euch Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. September 1990</h6>
          <p>
            Meine Tochter: Du musst jeden Tag den Rosenkranz beten, denn bei
            Erhebung dieses Gebetes für die Menschheit machst Dumichsehr
            glücklich. <br />
            Dies wird die Form sein in der Du mich den Herzen zur Erkenntnis
            gibst, die mich vergessen haben und ICH werde grosse Dinge für meine
            Kinder tun wenn sie mich Ehren und den Herrn durch mich verehren.
            Ich segne Euch Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. September 1990</h6>
          <p>
            Meine Kinder: <br />
            Betet dem Herrn, er wird Euch erhören, Jesus ist gekommen, und betet
            mit Euch, von ihm sollt ihr lernen. <br /> Er ist voller Liebe zum
            Vater. <br />
            In dem Gebet ist der Weg, die Wahrheit, das Leben und Er, Er wird
            Euch erleuchten damit ihr zu Ihm gelangt. Habt keine Angst, solche
            die dem Vater mit Demut beten brauchen nichts zu fürchten, denn sie
            finden zu Ihm durch meinen Göttlichen Sohn. Aus seiner Quelle werden
            sie trinken, jene die beten und nicht sünden. Ich segne Euch. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20.September 1990</h6>
          <p>
            Meine Kinder: <br />
            Die Welt ehrt den Gott Baal, er ist der Materialismus, Gott möchte
            sein<strong>Erbarmen</strong>über diese Welt austeilen, deshalb
            bittet er dass man “<strong>seine Bermherigkeit“</strong>suche. Die
            Jugend vereehrt Baal, diese werden nach und nach in die Tiefen des
            Bösen fallen. Wendet Euch alle zu Gott.” <br />
            Du sollst diese Botschaft verkünden, die Bermherzikeit ist eine
            grosse Gelegenheit für die Welt, eilet, es könnte schon sehr spät
            sein.”Fürchtet Euch nicht “ Maria. <br />
            Seid gesegnet Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. September 1990 (im Gebet)</h6>
          <p>
            Maria: <br />
            Ich werde Dir meine -verkündigungen in dem Moment wo es nötig ist
            machen, während dessen bittet Gott um Gebet und Sühne, für den
            Erlass der Sünden, ohne Gebet gibt es keine Reue. <br />
            Die Welt ist an der Grenze der Menschenzerstörung. Meine Seele ist
            traurig, zum Himmel erheben sich die Stimmen, um diese zu stillen,
            müssen die Gebete erhoben werden. betet, betet, meine armen Kinder.
            Ich segne Euch Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Oktober 1990</h6>
          <p>
            Meine Tochter: <br />
            Bald wird ein Krieg beginnen der sehr grausam sein wird .
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18. Oktober 1990</h6>
          <p>
            Maria meine Tochter <br />
            Ich möchte dass Du für den Frieden der Welt betest und Sühne machst
            und diese dem Herrn widmest. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>23. Oktober 1990</h6>
          <p>
            (während ich den Rosenkranz betete) <br />
            Am heutigen Tage hatte ich eine Vision der Allerheiligsten Mutter,
            sie war ganz in weiss vom Kopf bis zum Fuss. Zuerst breitete sie
            ihre Arme aus, und aus ihren Händen strahlten ausserordentlich
            weisse und durchsichtige Lichter. Ihr wunderschönes Antlitz war
            intensiv traurig ihr Gesicht schaute nach unten. Danach faltetete
            sie ihre Hände zum Gebet <br />
            und indem sie ihren Blick erhob verschschwand sie ohne ein Wort zu
            sagen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Dezember 1990</h6>
          <p>
            (im Gebete sagte die allerheiligste Mutter) <br />
            “Ich bin Maria, die Mutter aller Schmerzen und unsere Frau der
            Tränen”
            <br />
            Sie sprach zu mir von allen den Beleidigungen die gegen den Herrn
            unaufhörlich gemacht werden und zeigte mir das “
            <strong>HERZ JESU</strong>” von Dornen gekrönt.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. September 1991</h6>
          <p>
            Tochter, das Gebet ist das verbindende Band zwischen Gott und den
            Menschen. <br />
            Eines morgens als ich aufwachte und zu beten begann, hatte ich die
            Vision von Jesus am Kreuz und er sagte : <br />
            <strong>“ Ich habe Durst, gebet mir zu trinken”.</strong>
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11. März 1992 ( im Gebete)</h6>
          <p>
            Tochter: <br />
            Erhöre die Mitteilungen Deiner Mutter welche wegen so vielen auf
            Abwegen gelangten Kindern weint. Ich möchte, dass Du unentwegt
            betest.¡ Mit wie vielen Sünden wird der Herr beleidigt! Wenn man
            bedenkt dass er am Kreuze gestorben ist und sich für Euch hingegeben
            hat, ihr seid unwürdig dem Herrn. <br />
            Betet alle damit die Welt sich bekehre. <br />
            Betet, macht Sühne und schaut auf die Glorie von Jesus Christus,
            lest das Evangelium, und übet die Worte Gottes mit Ehrlichkeit im
            Herzen aus. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. Juli 1994</h6>
          <p>
            Morgens, sehr früh während ich meine Gebete ausführte, sah ich vor
            mir einen ENGEL, als ich in sah empfand ich grosses Erfreuen,
            innerlich und äusserlich, und ein tiefer Seufzer entsprang aus
            meinem Munde bei der Gegenwart dieses Engels von auserordentlicher
            Schönheit, die mich rechtlich beeindruckte. Es war nicht nur seine
            Schönheit sondern aus seiner Gegenwart strahlte eine enorme
            Wohltuung welche aufmicheinwirkte und ein inneres Glück
            befielmichsehr schwer in Worten zu beschreiben. Er war in weiss
            bekleidet, eine Kordel war um seine Taille gebunden und sein Anblick
            war stark und strahlend, bei seinem Anblick schätzte ich einen
            Jungen von ca. 17 Jahren, seine Haare waren blond und lang bis unter
            seine Ohren. In einen seiner Hände trug er einen langen Stab der
            über ihn hinausragte und auf den Boden stämmte. Er stand vor mir
            eine Weile ( ich weiss nicht wie lange), er sagte nichts,
            schautemichan, mit grosser Intensität. Ich frug ihn : <br />
            “wer bist Du?” <br />
            A: Ich bin ein Engel, und gehöre den Wächtern der himmlichen Heere
            an, im Kampfe mit dem Ezengel Michael gegen den Teufel. <br />
            Später sagte er: <br />
            Höre aufmerksam zu ¿ glaubst Du dass der Herr einwilligt dass weiter
            schreckliche Dinge in seinem Hause geschehen? Gott ist einVater, der
            korrigiert. Seine<strong>LIEBE</strong>erreicht die Guten und die
            Bösen, seine Geduld ist unendlich, Gottes Zorn hat sich noch nicht
            gegen die Undemütigen ausgebreitet, weil nur er, der Schöpfer alles
            Gegenwärtigen ist, ER ist die Macht über aller Macht, Sein Erbarmen
            ist unendlich, die Liebe Gottes ist der Retter. Glücklicher Du der
            gut handelts, gebenedeiet seien alle Deine Leiden ( hier schwieg er
            als warte er auf mein Sprechen) ich fragte ihn ¿was willst Du das
            ich tue?
            <br />
            A: Ich bin nur ein Diener,<strong>Er</strong>
            <strong>Der</strong>ist sendetmich, sei eine gute Dienerin und tu
            was ich tat. <br />
            Gelobet und geehrt sei der Herr,für immer geehrt und geheiligt.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. März 1995</h6>
          <p>
            (wahrend ich den Rosenkranz betete, die glorreichen Geheimnisse)
            <br />
            An diesem Tage hatte ich eine Vision der Allerheiligsten Jungfrau,
            der Muttergottes von Schoenstatt Mutter, Königin und Herrscherin.{" "}
            <br />
            Die Jungfrau mit dem Kinde gaben dem Bildnis Leben, Sie die
            Allerheiligste Jungfrau lächelte und das Kindlein auch mitten in
            einem grossen strahlendem Licht, das Heilige Kind in Ihren Armen
            streichelte lieblich mit seinem Händchen das Gesicht der Heiligsten
            Jungfrau, danach beugte sich das Kind und küsste das Herz von Maria,
            und sein Händchen streichelte die Brust lieblich somit das Herz von
            Maria welches es in seinen Händchen hielt als würde es Es hingeben
            und während es dieses tat, segnete es mit der anderen Hand auf dem
            unbefleckten Herzen der Jungfrau, die ganze Stadt und die Welt.immer
            waren beide Antlitze lächelnd und glücklich und stahlten grosses
            Vetrauen aus, danach verschschwand die Vision. <br />
            Hiernach ward meine Seele sehr erreget mit grossem Erfreuen und
            innerem Frieden.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20. März 1995</h6>
          <p>
            Maria Tochter mein. <br />
            Du musst immer dem Eucharistischem Herzen meines Sohnes Jesus
            vertrauen, ich möchte, dass Du in Deinen Gebeten Dich immer an Ihn
            richtest, heute bitte ich Dich Tochter meines Herzens viel für die
            Kranken zu beten und ermittele dass jede Seele und jedes Herz mit
            Kraft dem Herzen Christi, der für eine jeden von Euch leidet,
            zugewendet wird,.Betet besonders für die Kranken, vertiefe Dich in
            die Passion und bitte mittels diesem einfachen Gebet dass Euer Leben
            dich bekehre, seid ausdauernd in diesen drei Bitten und bald werdet
            ihr den Wechsel spüren. Es mag sein dass es am Anfang ein wenig
            schwierig ist, aber wenn ihr es erfüllt werde ich Grosse Gnaden
            versprechen, erfüllt alle diese meine Bitte, die Bekehrung ist
            dringend, ich möchte alle meine Kinder haben.¡ die Tore des Himmels
            sind für alle geöffnet ! ¡ Öffnet Eure Herzen! Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22. März 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Heute möchte ich Euch vor dem Bösen bewahren, der Teufel arbeitet,
            er wird vesuchen Euch zu beherrschen, sogar durch solche die in der
            Kirche sind, Satan und seine bösen Geister, geben sich nicht leicht
            bekannt sondern, tarnen sich mit einem Lammfell, und mit Listwerden
            sie Böses sähen, er wird die Kirche angreifen und alle Orte wo
            Gottes Wort glehret wird. Er wird sich dort einnisten um sie zu
            verderben, und in seine Todesfalle werden viele fallen, besonders
            die die nicht wachsam des Eingangs ihres Herzens sind, deshalb bitte
            ich permanent, fastet, betet, foltert Euren Körper um Euch innerlich
            zu stär- ken, ich spreche zu allen, bleibet wachsamt denn der Teufel
            wacht und wartet immer auf die Gelegenheit Euch zu verderben. <br />
            Dies sage ich Euch nicht um Euch zu beängstigen sondern um Euch zu
            warnen. Bereitet Euch vor wie die Erde für die Saat, Tag für Tag mit
            Beharrlichkeit in jedem Ding welches ihr vollbringet, segnet den
            Namen des Herrn. <br />
            Gott segne Euch meine Kinder. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1. April 1995</h6>
          <p>
            Eines Tages wäahrendinc den Kreuzweg machte (hatte ich in meinem
            Schlafzimmer folgende Vision.) Vor dem Alleheiligsen der Kirche, das
            verletzte Herz Jesu, das Herz hatte eine tiefe Wunde, und als es
            klopfte, triefte ein dicker Tropfen Blut. <br />
            Zugleich liess mich der Herr die Schmerzen dieses Krampes fühlen,
            bei jedem Tropfen physischer und moralischer Schmerz. Dieser Schmerz
            war so unbeschreiblich als der Herr ihn mir fühlen liess mich eine
            Ohnmacht überfiel, und ich merkte das meine Herz es nicht ertragen
            konnte und der Herr entzog mit das Leid sonst wäre ich gestorben.
            <br />
            Der Herr zeigte mir wie viel LIEBE es in seinem angebeteten Herzen
            gibt. Wie viel LIEBE Hat er im Tabernakel LEBENDIG UND GEGENWARTIG.
            Grosse, unendliche LIEBE Zu uns, mit jahrhundertelangem Leiden in
            seiner erlösenden Passion! <br />
            Die Heilige Dreifaltigkkeit ist dem Allerheiligsten Eucharistischen
            Herzen Jesu Gegenwärtig. <br />
            Nach dieser Vision eschienen folgende Worte: <br />
            „ICH BIN DAS ALLERHEILGSTE EUCHARISTISCHE HERZ JESU, BETET MICH
            IMMERDAR IN WIDERGUTMACHUNG“.Folgendes Gebet was duch seine
            Eingebung mir gegeben: <br />
            Allerheiligstes Eukaristisches Herz Jesu, ich vertraue unermesslich
            auf Dein Erbarmen. Ich bitte Dich mit aller Bescheidenheit mir den
            Glauben zu geben um mich Deiner unendlichen Barmherzigkeit zu
            ergeben, denn es sind meine menschlichen Kräfte geschwunden und nun
            steht mir nur noch zu, mein Vetrauen Deinem unendlichen Erbarmen
            zuzuwenden, denn DU wirst mein Flehen nicht überhören. Hier bin ich,
            Herr zu Deinen Füssen und bitte Dich innigstlich alle meine Sachen
            und Probleme zu ordnen, gemäss Deiner Liebe und himmlischer
            Fürsorge, da ich weiss dies wird das Beste für mich sein, lasse es
            zu, ich bitte Dich, wenn es für das Wohl meiner Seele ist. ¡Nimm
            Herr! Mein Problem
            <br />
            ¡Nimm mein Herz! <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu. <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu <br />
            Ich vertraue auf Dich Eucharistisches Herz Jesu.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21. April de 1995</h6>
          <p>
            (in der Kapelle von Unserer Mutter von Schönstatt) <br />
            Am heutigen Tag während ich Jesus im Sakrament anbetete, sagte die
            Allerheiligte Jungfrau: <br />
            Geliebte Kinder: <br />
            Heute bin ich gekommen mit der Bitte dass ihr betet, für alle
            Menschen die Not leiden, für die Hungernden, die Besorgten und die
            Kranken, für die Kinder Ofer dieser Welt, voller Bosheit, verseucht
            durch die Sünde. Betet meine gelieben Kinder, die Menscheit
            schreitet zu ihrer eigenen Zerstörung, ihr seid die Auserwählten,
            damit ihr durch das Gebet die Strafe Gottes aufhalten könnt. <br />
            Betet zu eurem Vater im Himmel, machet dies im Namen seines Sohnes
            Jesus Christus. <br />
            Gebet.Gebet. Gebet. Erhöret diese Mutter im Himmel, sie weis wie sie
            ihre Kinder <br />
            retten kann, seid bescheiden damit euer ebet zum Himmel kommt.{" "}
            <br />
            Gesegnet und gelobet sei Gott. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10. Mai 1995</h6>
          <p>
            Verkündung von Jesus. Wenn der Tag des Gerichts kommt, werden alle
            auferstehen, ich versichere Euch ab den ersten Menschen Adam und
            Eva, die erste Frau und mit ihnen bis zum letzten der letzten. an
            diesem Tag wird die ganze Schöpfung Auferstehen Himmel und Erde
            werden sich sehen. Der Vater, der Sohn und der Heilige Geist, die
            Glorie der Glorien, gesegnet seien die Gesegneten und verdammt die
            Verdammten. Ich habe Euch Maria meine Mutter gesandt, wer sie
            erhört, erhört mich.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11. Mai 1995</h6>
          <p>
            Als ich die Jungfau über die“Frau“ fragte, sagte sie Du bist eine
            „Frau“, mein Wunsch ist <br />
            wenn ihr an MICH denkt, trennet mich nie von Meinem Sohn Jesus seit
            meiner Mutter Leib wurde ich für IHN geschaffen, mein Leben ist für
            IHN, mit IHM und in IHM und jetzt wo ich bei IHM bin, ist mein
            ganzer Himmel ER. <br />
            Frauen der Welt, das dritte Milenium kommt näher, die Frau wird in
            dieser Zeit herrschen. <br />
            Seit stark, nicht dass die Essenz verloren gehe die Gott in Euch
            legte als er Euch das Leben schenkte.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Juni 1995</h6>
          <p>
            Verkündung von Jesus. <br />
            Die Menschheit hat sich nie gefragt, wie viele Tränen ich für Euch
            vergossen habe während meiner Passion und wie viele bittere Tränen
            meine heilige Mutter auch vergoss um der Erlösung zu helfen. <br />
            Ich bitte Euch ehret jede Träne die ich für euch vergossen habe in
            diesen bitteren Stunden <br />
            Ich verspreche jedem der täglich fünf Vaterunser, fünf Ave Maria und
            fünf Glorien betet werde ich: <br />
            zusammen mit meiner Allerheiligsten Mutter am letzten Kamfe des
            Lebens beistehen. <br />
            die Bekehrung seiner Seele <br />
            eine wirkliche Reue seiner Sünden <br />
            am Tag des Gerichts, die Vergebung um mit mir in die Glorie
            einzugehen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. August 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Der Friede und die Liebe des Herrn sei mit Euch. <br />
            Heute bin ich gekommen mit der Bitte täglich den Heiligen Rosenkranz
            zu beten. <br />
            Um Eure Bekehrung zu beginnen, der zweite Schritt wäre eure Seelen
            zu reinigen durch das heilige Skrament der Beichte, die Heilige
            Messe, solche die es möglich habt, geht täglich zu Messe ohne
            Sonntags zu fehlen und betet den heiligen Rosenkranz. Dieses
            schlichte Gebet wird Euer Leben wandeln. Habet Ausadauer mit diesen
            drei Bitten und ihr werdet euch bald gewandelt fühlen, es mag sein
            dass es zu Beginn schwierig ist, aber wenn ihr es mact werde ich
            grosse Gnaden versprechen. Erfüllt bald diesen Wunsch die Bekehrung
            ist dringend, ich möchte alle meine Kinder bei mir haben. <br />
            „Die Türen des Himmels sind für alle geöffnet.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. August 1995</h6>
          <p>
            Maria, Töchterlein meines Herzens: <br />
            Ich möchte dass Du den Himmel anschaust, wo ich in gloreichem Leib
            und Seele, in Begleitung der Engel und Heiligen lebe. <br />
            Schaumichan meine Tochter ( sie sahmichan und breitete ihre Hände,
            aus ihnen strahlten Blitze aus reinstem Lichte) und sie sagte:{" "}
            <br />
            schau nur meine Freude, erlebe sie mit mir, es ist ein Geschenk der
            Mutter des Himmels welches ich mit Dir teilen möchte. <br />
            Meine Seele lobet den Herrn und meine Geist erfeue sich in der
            Glorie Gottes, ewig ist die Barmherzigkeit meines Gottes und
            Erlösers, glücklich solche die auf den Herrn warten da sie an der
            Quelle des lebendigen Lebens gestillt werden und niemals mehr Hunger
            noch Durst empfinden denn sie werden Gott sehen. Sei bescheiden
            meine Tochter, predige die Bescheidenheit, Du hast einen grossen
            Kampf ausgestanden, hab keine Angst. Ich werde bis zum Ende bei Dir
            sein, ich bin heilige Hostie in Deinem Herzen. Amen Aleluya Amen
            Aleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. September 1995</h6>
          <p>
            Meine Kinder: <br />
            Widersprechet nicht Eurem Vater, der im Himmel ist, im Gegenteil
            versucht immer ihm zu danken und zu loben, leidet alles mit grosser
            Demut und Geduld, da die Gnade der Geduld Euch heiligen wird, gebet
            alles unserem Herrn, suchet nicht die Oberflächlichkeiten der Welt,
            sondern im Gegensatz betet, betet den heiligen Rosenkranz, so oft
            wie möglich, während ihr betet, werdet Ihr grosse Gnaden erlangen.{" "}
            <br />
            Wenn ihr nicht betet und mindestens einmal im Monat beichtet werdet
            ihr geistig nicht wachsen und dem Gegner Gelegenheit geben Euch mit
            wenig Kräften anzutreffen! <br />
            ¡Wendet Euch zu Gott meine Kinder! Gebt dieses Bekannt Amen Aleluya
            Amen <br />
            Gott segne Euch!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. September 1995</h6>
          <p>
            ¿Warum werden meine Mitteilungen aufgehoben? <br />
            Ezequiel Kap.5, Kap.32
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. September 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Ich spreche zu allen die sich heute versammelt haben ummichzu ehren
            ¡ Ich bin so glücklich!! Da ich einen jeden von Euch sehe und höre
            jeden einzelnen, ich sehe Hände die sich ausbreiten und Fürbitten
            anflehen.
            <br />
            Ich verspreche all diese Bitten in den Himmel zu nehmen und zu
            Füssen der Heiligen Dreifaltigkeit niederzulegen, Ich bin Eure
            Anwältin, mächtige Vermittlerin vor Gottes Trohn. Ich bitte Euch
            Gebet und Versöhnung, jenen die diese meine Bitte erfüllen
            verspreche ich Vermittlung damit sie den wirklichen Frieden des{" "}
            <br />
            lieblichen<strong>Herzens Jesu</strong>und Heilung der Seele
            erlangen. Ich möchte an diesem besonderen Tag meine Bitte
            wiederholen WEIHET EUCH ALLE DEM UNBEFLECKTEM HERZEN JESU, da mein
            unbeflecktes Herz siegen wird und ihr die Euch weihet mit ihm siegen
            werdet, weihet Euch mir mit dem täglichen beten des heiligen
            Rosenkranzes. <br />
            Ach meine Kinderlein, wenn ihr wüsstet all die Gnaden die ihr
            erlangt wenn ihr mit Demut den Rosenkranz betet.! <br />
            Gebenedeiet und gelobet sei die Heilige Dreifaltigkeit in der
            Heiligen Eucharistie vergegenwärtigt. Amen. Aleluya. Amen Aleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Oktober 1995 (beim Gebet in meinem Schlafzimmer)</h6>
          <p>
            Geliebtes Töchterlein; Mit wieviel Freude erhalte ich all das Lob,
            Gebete, Tränen der Liebe insbesondere für meinen geliebten Sohn,
            beonders an diesem Tage. <br />
            Die Welt muss sich meinem unbefleckten Herzen weihen. Die Zeiten
            haben sich verkürzt, die Zeichen werden bekanntgeben dass
            schreckliche Dinge geschehen werden und dass alle Wahrsagungen die
            ich Euch in diesen Zeiten mitteilte in Erfüllung gehen, noch
            intensiver als in den letzen Zeiten um Euch zur dringenden Bekehrung
            zu Gott zu wenden. Mein Mutterherz leidet weil viele Menschen sich
            taub stellen um meine dringenden Rufe zur Bekehrung überhören.{" "}
            <br />
            Der Herr ermittelt in seiner unendlichen Barmherzigkeit Euch
            verschiedene Ansagungen der schrecklichen Dinge die über die
            Menschheit kommen werden zu machen, die Dunkelheit welche sich
            nähert und das Licht nicht leuchten lässt. <br />
            Die fürchterlichsten Foltereien warten auf Euch, die körperlichen
            denen ihr ausgesetz seid sind schon kaum ertragbar aber auch die
            geistigen werden kommen und solche sind so geiselnd wie jemals ein
            Mensch seid der Schöpfung erfahren hat. <br />
            Der Hass des Gegeners wird mit all seiner Wucht kommen und die
            Nationen der Erde werden irre. <br />
            Das Feuer wird vom Himmel fallen und wird alle durch Panik erstarren
            lassen, die Stürme werden so mannfaltig sein dass das ganze
            Universum zittern wird, danach wird nur ¾ der Menschheit bestehen.{" "}
            <br />
            Das Zeichen welches ich Euch angesagt habe wird zu gunsten der
            Auserwählten sichtbar sein, Gott der Vater wird Euch Zeit geben Euch
            in schon vorbereitenten Orten die für diesen Moment vorgesehen sind
            zu Bergen, die Kinder welche mich schon erhört haben sind schon
            vorbereitet und an jenem Tage fallet zu Füssen, wie Súhner und betet
            folgendes: <br />
            Allerheiligste Dreifaltigkeit dass Dein Heiligster Wille sich
            erfülle hab Barmherzigkeit mit uns, hab. Barmherzigkeit, hab
            Erbarmen, hab Erbarmen ! Oh Gott, Barmherzigkeit, Barmherzigkeit!{" "}
            <br />
            Für das Blut des Lammes hab Erbarmen! <br />
            Für die Passion des Lammes, hab Barmherzigkeit <br />
            Für die Wunden des Lammes hab Erbarmen. <br />
            Für Deinen Sohn das Lamm Gotes erhöre uns. <br />
            vater erBarme Dich unser im Namen deines Heiligen Sohnes JESÚS.
            Amen.
            <br />
            Ich bitte Euch DRINGEND zur Bekehrung des unbefleckten Herzen von
            Maria, um diese fürchterlichen Ereignisse zu lindern, die wegen der
            Sünden über die Menschheit kommen werden, meine Kinderlein, die Welt
            wandelt in ekligem Schlamm, und ist injeder Menge von Unreinheiten
            verwickelt, unmöglich eine Vergleich zu finden, da seid der
            Schöpfung nichts gleiches vorhanden war. Der verdorbene Geruch
            steigt heftig zu Gott und wenige Seelen beten, die Strafe steht
            schon vor den Toren.
            <br />
            Meine Fürbitten halten Gottes Hand schützend, ich bitte um mehr
            Gebete, besonders von den GEWEIHTEN, betet unaufhörlich und vor
            allem liebet Gott, ER der HEILIG, HEILIG, HEILIG ist. <br />
            ¡Dass die Heilige Gottesfurcht wieder in die Herzen zurückkehre!
            Solche die in meine Worte glauben und sich bekehren werden sich
            retten. Gebet diese Botschaft bekannt, heute wie gestern DRINGENDE
            BITTE ZUR LIEBE GOTTES. Ich segne Dich Töchterlein meines Herzens.
            <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29. Oktober 1995 (im Gebet)</h6>
          <p>
            Liebe Kinder: Ihr glaubet der Himmel sei ein ferner und
            unerreichbarer Ort., einige glauben nicht einmal an seine Existenz,
            heute möchte ich Euch sagen, der Himmel ist sehr nahe von Euch.{" "}
            <br />
            Ich lade Euch ein in eine Kirche zu gehen und Euch dem
            Allerheiligsten zu nähern, schaut zu Ihm, und ihr sehet den Himmel
            auf Erden da JESUS im Himmel ist, und dort wo er ist, dort ist der
            Himmel ¡Er ist GOTT! Betet in der Kenntnis dass Er in allen
            Allerheilig- <br />
            sten gegenwärtig ist . Lasst Euch von Ihm leiten, tuet was Er Euch
            bittet. Ich liebe Euch alle <br />
            Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31. Oktober 1995</h6>
          <p>
            Nach der Kommunion, habe ich eine Vision gehabt, ich schloss die
            Augen um mit Jesus zu sprechen. <br />
            Er erschien mir mit dem Angesicht des Heiligen Tuches, aber nicht
            wie es auf einem Bild erscheint sondern echt, seine ganzes Antlitz
            erleuchtet und mit allen sichtlichen leiden, dies machte einen
            tiefen Eindruck auf meine Seele. <br />
            ER, mit seinen geschlossen <br />
            Augen schaute in mein Herz und ich sah ihn an mit meinem Herzen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. November 1995</h6>
          <p>
            Meine Kinder: <br />
            Ich bringe Euch ein Wort des Himmels ¡ HOFFNUNG! ¡HOFFNUNG!
            ¡HOFFNUNG!
            <br />
            ¿ Wie könnten meine Kinder die LIEBE GOTTES verstehen wenn sie ihn
            Verzweiflung leben? <br />
            Überleget <br />
            Die Hoffnung ist ein Erwarten auf Gott und nur auf IHN, alles von
            IHM erwartend, mit all Euerer Kraft, aber immer auf die Hoffnung
            schauend welche im Himmel ist. <br />
            Die LIEBE die GOTT Euch widmet befindet sich in der Hoffnung, weil
            GOTT LIEBE IST und die LIEBE GOTTES beinhaltet alles <br />
            Gelobet sei ¡Jesus!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. November 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bin gekommen Euch zu besuchen und Euch mit Segen zu vesorgenden
            ich vom Himmel brachte, obwohl vielen von Euch es schwerfallen wird
            zu Glauben, da ihr keinen Glauben habt, Kinderlein, wenn ihr Eure
            Herzen öffnet, diese Mutter könnte Euch zur Bekehrung führen, ich
            bringe Euch viel Liebe und Hoffnung. <br />
            Ich möchte dass alle meine Botschaften erhört werden. Ich die Mutter
            von Jesus bin sehr glücklich unter Euch da ihr schon begonnen habt
            Euch zu bekehren und bald werdet ihr den Herrn sehen, er wird in
            Euren Herzen herrschen, besonders in den Jüngeren, auf sie hat er
            all seine Hoffnung gesetzt. <br />
            Ich bitte Euch eine grundsätzliche Änderung in Eurem Leben
            einzuführen, verfolgt mit Aufmerksamkeit meine Botschaften, in ihnen
            werde ich Euch lehren sich Gott zu nähren. <br />
            ¡Danke dass ihre Eure Herzen geöffnet habt! <br />
            Dies ist eine Zeit der Barmherzigkeit. <br />
            Es leuchtet ein Licht mitten zwischen Euch, Betet, Betet. <br />
            Gelobet und gepriesen sei dass ALLERHEILIGSTE EUCHARISTISCHE HERZ
            JESU.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18 November l995</h6>
          <p>
            Seid bewusst geliebte Kinder, dass Gott lebet und sehr nahe von
            Euch.
            <br />
            Er ist der Schöpfer von allem was Eure Augen sehen und noch viel
            mehr.
            <br />
            Ich möchte dass ihr ernsthaft über dieses nachdenket und die heilige
            Bibel lest, bittet den Heiligen Geist dass er Euch erleuchte für ein
            besseres Verständnis. <br />
            Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18 November 1995</h6>
          <p>
            Gestern Abend hatte ich eine Vision. <br />
            Ich sah einen Garten voller Rosenknospen alleweiss sehr eng
            zusammen.
            <br />
            Als ich über meine Vision fragte sagte sie mir. <br />
            Weisse Rosen sind das Zeichen der Rheinheit.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22 November 1995</h6>
          <p>
            Arbeitet, Arbeitet meine Kinder, Arbeitet mit Freude für das Reich
            Gottes ¡Ehre sei Gott! Amen. <br />
            (Eine private Botschaft)
            <strong>” Gebet um um Weisheit zu bitten”</strong>
            ¡Mein Gott und Herr der Barmherzigkeit! <br />
            Gib mir die Heilige Weisheit welche aus Deiner unendlichen Güte
            hervorgeht. <br />
            Öffne mir die Augen des Glaubens und des ewigen Lichtes. <br />
            Damit ich mit ihnen sehen kann, weil Deine unendliche Weisheit mein
            Herr, strahlender als die Sonne ist. <br />
            Leite meine Gedanken Herr mit Deiner Weisheit, damit sie Quelle
            meines Wissens und Handelns sei. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 November 1995</h6>
          <p>
            Heute hatte ich eine Vision der Heiligen Jungfrau, vertieft im
            Gebete, Ihr Antliz schaute nach unten. Sie hielt ihre Hände
            gefaltet, während einiger Minuten blieb sie in Schweigen dann sagte
            Sie zu mir: <br />
            Geliebte Kinder, ich rufe Euch alle zur Behkehrung und damit dies
            geschehe müsst ihr viel beten. Bittet dem Heiligen Geist, mittels
            der täglichen Gebete, dass Er in Euren Herzen handle, damit ihr wie
            richtige Christen leben könnt. <br />
            Das Gebet ist so wichtig, ihr könnt es Euch kaum vorstellen. <br />
            Es kann Euch einen grossen Weg zur Gnade eröffnen, wenn ihr
            beständig seid. Beginnt heute mit Eurem Gebet damit die Liebe Gottes
            alle Winkel Eures Herzens erfüllt. <br />
            Der Heilige Geist ist der einzige der Euch bekehren kann und Euch
            zur Heiligkeit führen wird. <br />
            Er ist der Vermittler aller Gnaden welche vom einzigen HEILIGEN,
            ALLERHEILIGSTEN <br />
            kommen die HEILIGE DREIFALTIGKEIT. <br />
            Gesegnet seid meine Kinder. <br />
            Amen,Halleluya. Amen, Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 November 1995</h6>
          <p>
            Ich werde versuchen Euch in Worten zu erklären was Gott meiner Seele
            ohne Worte mitteilte. <br />
            Nach der Heiligen Kommunion des Fleisches und Blutes Jesu. Die
            unendliche LIEBE GOTTES überflutetemich. Diese unendliche LIEBE,
            gelang zu meiner Seele in tiefem Schweigen, ER war in mir und ohne
            Worte teilte Er meinem Herzen mit dass diese unendliche Liebe GOTTES
            und durch sie in uns, alle die die Heilige Kommunion empfangen in
            seiner unendlichen Barmherzigkeit sich allen Seelen mitteilt die Ihn
            empfangen um sie zu rufen und Ihnen Leben zu geben, mit seiner
            UNENDLICHEN LIEBE <br />
            gegenwärtig in der HEILIGEN EUCHARISTIE. <br />
            Und DIE LIEBE sagte mir, bete in folgender Weise: <br />
            ¡Oh, unendliche Liebe die Du nie aufhöhrest zu rufen! <br />
            ¡Oh, unendliche Passion, die Du nie aufhöres zuleiden! <br />
            Du rufest <br />
            Du leidest <br />
            Und liebest die Seelen weil es Seelen Deiner Seele sind! <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 November 1995</h6>
          <p>
            Jeus sagt <br />
            ¡Ich werde nichts meiner Seele weigern welche mit Vertrauen dem
            ALLERHEILIGSTEN EUCHARISTISCHEM HERZEN JESU sich zuwendet. <br />
            Ich rufe Euc, ich erwarte Euch.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 November 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Macht Euer meinen “Gesang”. Lobet der Herren mit ihm. Weil jedesmal
            wenn ihr es tut, werden die Engel und die Heiligen im Himmel mit
            Euch singen. <br />
            Amen Halleluya, Amen. Halleluya (schreiben den Lobgesang der
            Heiligen Jungfrau ab) <br />
            “Meine Seele singet die Grösse des Herrn und mein Geist erfreuet
            sich in Gott meinem Erlöser, weil er mit Güte die Bescheidenheit
            seiner Dienerin geschaut hat. <br />
            In Zukunft werden alle GenerationenmichGlücklich nennen, Weil der
            Allmächtige in mir grosse Dinge vollbracht hat: <br />
            ¡ Sein Name ist Heilig ! Seine Barmherzigkeit verbreitet sich von
            Generation zu Generation Über solche die ihn fürchten. <br />
            Er öffnete mit Kraft seinen Arm und zerstreute die hochmütigen
            Herzens Warf die Mächtigen von ihrem Trone und erhob die Demütigen
            Versorgte mit Gütern die Hungrigen und verabschiedete die Reichen
            mit leeren Händen, Er versorgte m it HilfeIsrael, seinen Diener, und
            erinnerte sich seiner Barmherzigkeit. <br />
            Wie er es schon unsreren Vätern versprochen hatte, zugunsten Abraham
            und seinen Nachkommen für immer.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>30 November 1995</h6>
          <p>
            Nachdem ich die Heilige Kommunion Empfangen habe sagt Jesus: <br />
            „Ich bin das unendliche Gut das für die Seelen leidet.“ <br />
            Bringt Seelen zu meinem Herzen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 Dezember 1995 (erster Freitag)</h6>
          <p>
            Nachdem ich die Heilige Kommunion Empfangen habe sagt Jesus: <br />
            Ich bin „DAS ALLERHEILIGSTE EUCHARISTISCHE HERZ JESU“ <br />
            Kommt meinem Herzen näher, habt keine Angst ich werde Euch
            beglücken. Ich bin die unendliche LIEBE.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>
            1 Dezember 1995 (während des Gebetes sagte die Allerheiligste
            Mutter)
          </h6>
          <p>
            Geliebte Kinder: <br />
            Ich spreche zu Euch allen in dieser Zeit der Barmherzigkeit. Gebet
            nicht auf euch Gott zu nähern. <br />
            Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. Dezember 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Der Heilige Geist, wohnet in uns, weil ihr Kinder Gottes seid. Lebet
            nich nach Euren Körpern, sondern gemäss dem Heiligen Geist, denkt
            und lebt Eurem Geiste nach, betend und mit der bitte Kraft zu
            bekommen um die Gnade zu erhalten. <br />
            Habet Mut, und bleibet im Gebet. Ich werde Euch immer begleiten,
            Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Dezember 1995</h6>
          <p>
            An diesem besonderen Tag, bin ich gekommen meine Kinder um meine
            grosse Liebe Euch zu schenken. Mein ganzes Wesen wurde in Reinheit
            bewahrt, durch die Heilige Dreifaltigkeit. In meinem Unbefleckten
            Leib wurde das Reine und Heilige Wort verkörpert, unendliches Licht
            welches die ganze Ewigkeit erhellt. In diesem wunderbaren Plan
            Gottes für die Rettung der gesamten Menschheit. <br />
            Überlegt dieses Meine Kinder, lasset das Licht in Eure Herzen
            scheinen, beginnet zu leuchten gleich Fackeln. <br />
            Geseligt, Gelobet und Gebenedeiet Sei Gott.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12 Dezember 1995</h6>
          <p>
            Sei gehorsam mein Töchterlein, erfülle Deine Aufgabe, Du bist
            Botschafterin des Glaubens, sei dem Allerhöchsten gehorsam, damit
            die Völker und Städte der Welt in Ihrem Gottesbekenntnis wachsen
            können. Die Völker werden Ihn Loben¡ Hab keine Angst! In der
            Einfachheit Deines Herzens zeigt sich der Herr. Gelobet Sei DAS
            ALLERHEILIGSTE EUCHARISTISCHE HERZ JESU.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12. Dezember 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bin gekommen um Euch zum wirklichen Weg zu führen welcher
            “Jesus” ist. <br />
            Diese Eure Mutter wird Euch den Weg erleichtern ¡Öffnet Eure Herzen!
            Erhöret meine Botschaft, ich möchte dass wir zusammen Laufen, auf
            dem Wege der zum Himmel führet. <br />
            ¡ Betet den Heiligen Rosenkranz. Gelobet sei die Ehre Gottes in ihm.
            <br />
            Gelobet sei Gott.!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Dezember 1995</h6>
          <p>
            (nach der Heiligen Kommunion) Jesus sagt: <br />“ Ich bin der ewig
            Liebende der Seelen”. Schauet mit Glorie auf mein Göttliches Herz,
            welches mit dem Feuer der Liebe für Euch entzündet und allen Blicken
            ausgesetzt ist.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17 Dezember 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bringe Euch das Licht welches ihr schon in Eurem Innern traget,
            aber noch nicht wegen Eurer Sünden sehen könnt, ich werde Euch
            helfen damit ihr das Licht von Christus in Euren Herzen sehen könnt.{" "}
            <br />
            Das Werk der BARMHERZIGKEIT des Herrn mit diesem Volke, wird die
            Grenzen überwinden und sich über die ganze Welt verbreiten. <br />
            Kinderlein ¡Bekehret Euch!, Alle, erhöret meine Lehren, so wird
            Frieden kommen auch die Liebe, erfreuet Euch über diesen einzigen
            Aufruf der dringend ist, um Gott zu finden. <br />
            ¡Gelobet sei der Herr !
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19 Dezember 1995</h6>
          <p>
            Geliebte Kinder <br />
            Ehret mein Jesukind, so wie wir es mit Josef geehrt haben, beginnet
            ihn im Herzen zu ehren, und lasset dass Er in Euren Heimen zu dieser
            Weihnacht geboren wird. <br />
            Ich spreche Euch von einer besonderen Gnade für Euch geliebte
            Kinder, lasset sie nicht ohne Bekehrung vorbeigehen. Ich liebe Euch
            alle. <br />
            Aleluya, Aleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 Dezember 1995</h6>
          <p>
            Keehret Euch zu Christus geliebte Kinder, beginnet ihn anzuschauen
            seit dem Augenblick seiner Geburt. Sehet die Armut in der der
            Erlöser geboren wurde. <br />
            Beginnet mit dem göttlichen Kinde zu leben, Euer Eigen lasst sterben
            und werdet für die<strong>Himmlischen</strong>Dinge geboren. <br />
            Alleluya, Alleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27. Dezember 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bitte Euch wie wirkliche Christen zu leben, KINDER GOTTES, so
            werden Eure Werke gut, ehrlich und dem Reiche Gottes gebührend sein.
            <br />
            Alleluya, Alleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28. Dezember 1995</h6>
          <p>
            Geliebte Kinder: <br />
            Betet Kinderlein Tag für Tag, um das GUTE zu
            <strong>erkennen</strong>
            und das BÖSE zu vermeiden. <br />
            Amen, Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1. Januar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Mein Wunsch ist zusammen mit der Mutter Gottes dieses Neue Jahr zu
            beginnen. <br />
            Leget Eure Wünsche auf<strong>mein Herz</strong> damit ich als
            Mutter von Jesus und Eure Mutter Euch vermitteln kann, das in Euch
            sich die Liebe des VATERS, des SOHNES UND DES HEILIGEN GEISTES
            verwirklichen kann. <br />
            Die unendliche Liebe Gottes möchte Euch helfen im GLAUBEN, in der
            HOFFNUNG und der LIEBE zu reifen, damit in Euren Leben die perfekten
            Werke der LIEBE GOTTES dem<strong>Erlöser</strong>, entstehen
            Erfreuet Euch meine Kinder, singet Loblieder der Heiligen
            Dreifaltigkeit.
            <br />
            ¡ Bekehret Euch ! <br />
            Amen Halleluya Amen Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. Januar 1996</h6>
          <p>
            Geliebte Kinderlein. <br />
            Betet den Heiligen Rosenkranz in Familie, bedenkt, dass wenn ihr
            dieses Tut ich Euch begleite, beginnet jetzt in diesem Neuen Jahre.
            Ich möchte in allen Heimen sein, um Euch bei den Schwierigkeiten zu
            helfen. Ich möchte dass alle Euch kennen. <br />
            Diese<strong>wunderbare Gnade</strong>schenket Euch der Herr,
            bleibet nicht gleichgültig, Ich liebe Euch alle! <br />
            Amen Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. Januar 1996</h6>
          <p>
            Betet für die anderen meine Kinder, erinnert Euch das Gott das Beste
            für Euch will. Seid hilfsbreit mit Euren Brüdern die leiden nach dem
            ihr für Eure Notwengkeiten gebetete habt bittet auch für die
            anderen.
            <br />
            Ihr lebt nicht allein, dank der unendlichen Liebe Gottes habt ihr
            Brüder und müsst die Liebe und den Frieden des Herrn mit ihnen
            teilen.
            <br />
            Segnet Gott und segnet die Brüder und so seid ihr angenehm in den
            Augen Gottes, ihr werdet grosse Geistige Wohltaten erfahren und der
            Friede Gottes wird in Eure Herzen kommen. <br />
            ¡Lebet dieses wie ich es Euch lehre! <br />
            Amen Halleluya Amen Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7 Januar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Bleibet im Gebet dem Allermächtigsten vereint, fühlet Sehnsucht nach
            seiner Liebe und seiet erfüllt von seiner unendlichen Liebe die
            alles kann. Lasset nicht diesen Moment der Liebe vorübergehen.
            Kennet Euch als Kinder Gottes, erhöret seine Worte und lasset diese
            in Eure Herzen kommen, flehet um diese Gnade seiner unendlichen
            Liebe. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Januar 1996</h6>
          <p>
            ¡Ich danke Euch dass ihr mir zuhöret! <br />
            Ich werde Euch bitten in andauernderm Gebet zur Ehre unseres
            Himmlischen Vaters zu leben. Ihr werdet seinen Willen erfüllen
            können wenn ihr die Kraft und das Licht des Heiligen Geistes habt,
            welche Euch nur mittels des Gebetes verliehen wird. <br />
            ¡Fastet! Mindestens einmal im Monat. Fasten bedeutet sich etwas zur
            Liebe Jesus zu versagen. Ihr kennet nicht die Macht des Fastens und
            des Gebetes. <br />
            ¡Beginnet zu fasten und betet<strong>alle</strong>zusammen und die
            Macht der Dunkelheit wird besiegt.! Ich liebe Euch alle. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11. Januar 1996</h6>
          <p>
            Betet! meine Kinder betet! Mit unendlicher Liebe, die Firnsternis
            breitet sich schon über die Menschheit. Nehmet Eure Vorkehrungen! Es
            ist der Heilige Rosenkranz. Gehorchet mir meine Kinder damit das
            Licht die Finsternis besiege. <br />
            Amen. Amen. Amen <br />
            Die Allerheiligste Jungfrau ist ganz in weiss gekleidet, ihr Antlitz
            ist in Tränen gebadet und bevor sie zu mir sprach zeigte sie mir ihr
            Antlitz.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11. Januar 1996</h6>
          <p>
            Jesus sagt: <br />
            Mit welchem Recht verwarnt ihr die Priester. Habe ich Euch nicht
            gelehrt einander zu lieben? <br />
            Wenn ihr, mein Volk, verdorben seid, muss ein jeder die Last seiner
            Sünden tragen. <br />
            Tut zuerst Eure Schulden Sühnen, seid meine wirklichen Verwalter um
            das Werk der Wiedergutmachung in rechter, Weise um mit Heiliger
            Furcht begonnen werden kann. <br />
            Hütet die Türen meines Reiches mit meiner unendlichen Liebe. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. Januar 1996</h6>
          <p>
            Ich sah ein trockenes Feld, voller Stacheln und Unkraut, mitten in
            einem wunderschönen Garten, voller Rosen mit grossen rosaren Rosen
            im Gegesatz zu dem Feld. <br />
            Mir sagt die Mutter: <br />
            In diesem Moment warten auf Euch viele Schwierigkeiten. Der
            entzückende Garten ist mein Herz, inmitten der Welt. Die Rosen
            stellen jene dar die den Rosenkranz beten, und sie wachsen wie
            grosse Bäume, die sich in den Himmel heben mit vielen geistigen
            Früchten. <br />
            Wer mir sein Herz gibt und den<strong>Rosenkranz</strong>betet,
            dürft ihr nichts in dieser Welt fürchten, weil das Heilige Gebet
            sich über alle Schwierigkeiten erhebt, und Euch vor jeder Gefahr
            bewahrt, und rasch Gottes Nähe bringt, Euch innerlich wachsen lässt
            und vermeidet von jeglicher Boshaftikeit angesteckt zu werden.{" "}
            <br />
            Das ist die Behütung dieGott Jenen gewährt, die den heiligen
            Rosenkranz beten. <br />
            Predigt dieses. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18. Januar 1996</h6>
          <p>
            Jesus sagt: <br />
            „Kommet zu mir, alle die bedrückt seid, und ich werde all Eure
            Leiden mildern“. <br />
            Kommmet und flüchtet in mein Heiliges Eucharistisches Herz. <br />
            Die allerheiligste Mutter sagt: <br />
            Wenn mein<strong>Göttlicher Sohn</strong>spricht, beten Himmel und
            Erde Ihn an. Jedes Wort Gottes hat einen Wert für die ganze
            Ewigkeit.
            <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. Januar 1996</h6>
          <p>
            Es sagt die Alleheiligste Mutter Maria: <br />
            Zu den Jungen sage ich, öffnet Eure Herzen dieser Mutter des
            Himmels, damit ich euch den rechten Weg zum Glück zeigen kann. Wenn
            ihr dies in Eure Herzen aufnehmet werde ich Euch auf den rechtenWeg
            führen und euch die wahre Moral, die in Euren Leben herrschen soll,
            zeigen. <br /> Ich werde euch lehren rein in Körper und Seele zu
            sein, damit ihr die wirkliche Freude kennet die von dem Herzen
            Jesus, meines Sohnes herkommt. <br />
            stellet Jesus in das Zentrum Eures Lebens.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 Januar 1996</h6>
          <p>
            Danke dass ihr mich erhöret: Ich werde euch bitten im Gebet zu leben
            und in andauernder Anbetung zum himmlischen Vater. Ihr könnt seinen
            Willen erfüllen wenn ihr die Kraft habt, die der Heilige Geist
            mittels des Gebets gibt. <br />
            Fasted. Mindestens einmal im Monat zu Beginn. Fasten bedeuted auf
            etwas zu vezichten zur Liebe<strong>Jesus.</strong>Ihr kennt nicht
            die Kraft des Fastens und Gebetes. <br />
            Beginnet<strong>alle</strong>zu fasten und zu beten und die Macht
            der Finsternis wird besiegt sein. Ich Liebe Euch alle. Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1. Februar 1996</h6>
          <p>
            Geliebte Kinder <br />
            ¡ Betet für den Frieden! Für den Frieden und die Liebe die in jedem
            Heim und in jedem Herzen herrschen sollte, besonders der Friede in
            den Herzen. <br />
            Bekehret Euch ganz dem Herrn! Suchet in allem seinem heiligen Willen
            zu erfüllen, das nichts Euch halte, kämpfet um dies in all den
            Wiedrigkeiten machen zu können. <br />
            Beginnet das Gebet, um entdecken zu können welches der Wille Gottes
            ist und diesen in Eurem Leben walten zu lassen. Findet den Frieden
            in Euren Herzen Mittels des Gebets. Ich liebe Euch alle. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. Februar 1996</h6>
          <p>
            Ihr seid Kinder die von Gott geliebt und gesegnet seid, hört meinen
            Botschaften zu, in ihnen ist eine wahre Bekehrung zu Gott enthalten.{" "}
            <br />
            Amen Amen <br />
            Leset den Psalm 14
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. Februar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            ¡Ich bin Eure Mutter! Ich bitte Euch alle Eure Hoffnung dem Herrn
            zuzuwenden. <br />
            Lobet den Herrn unendwegt, in allen Taten Eures Lebens, wachset
            innerlich durch das Gebet. Ihr könnt nicht in Freuden, leben wenn
            Gott nicht in Euren Herzen herrscht. Wenn ihr wirkliches
            Christliches Leben führen wollt, beginnt Jesus anzuschauen, und
            vertieft Euch in göttliche Dinge, biss gänzlich Eure Gedanken und
            Eure Herzen mit der Liebe Gottes erfüllt sind. <br />
            Interessiert Euch zu wissen , welches der Wille Gottes ist, mit
            innigem Gebet und fastend. <br />
            Schauet Euren Bruder der leidet. Reichet Eure Hände denen die es am
            meisten Notwendig haben, in dem ihr den innbrünstigen Wunsch für sie
            zu beten erfüllet. Auf diese Weise erhaltet ihr unglaubliche Dinge
            der Liebe Gottes. <br />
            ¡Stärket Euch! In Gebet wird der Friede in Euren Herzen wachsen.
            <br />
            ¡Seid gesegnet! ¡Ehre dem Allerhöchsten!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. Februar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Seid wirkliche Nachfolger Christi, gemäss der Lehre die Er Euch
            hinterliess. ¡Leset das Heilige Evangelium! Und beginnet Gott zu
            ehren. Kennt sein Heiliges Wort und was Er bestimmet. Gottes Wort
            dient nicht um nach der Welt zu leben sondern Euch vorzubereiten für
            ein Leben im Himmel. <br />
            ¡Erfreut Euch meine Kinder! Der Herr ist barmherzig mit denen
            sanften Herzens lasst diesen Besonderen Augenblick nicht
            vorübergehen. <br />
            Amen Hallleluya Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Februar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Seid stark in diesem Moment den ihr erleben müsst, ehret Gott mit
            Euren Leben. Das jeder Moment des Tages ein Lob dem Herrn sei, in
            dem ihr Eure Pflichten erfüllt und ein jeder dass Beste von sich
            gibt.
            <br />
            Handelt immer im Heiligen Geiste Gottes, damit ihr Sieger seid und
            Euer Vater im Himmel einen jeden von Euch bei seine Namen rufe und
            Euch als seine Kinder anerkenne. <br />
            Betet meine Kinder betet. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>(Die Rosen)11 Februar 1996</h6>
          <p>
            ¡Betet meine Kinder und glaubt an das Evangelium! Bekehret Euch dem
            Herrn! Und alle Völker der Erde werden Frieden haben. <br />
            Betet inniglich, damit viele Seelen sich dem Herrn zuwenden. Betet
            für die Kranken, viele leidenohne die Liebe Gottes zu kennen, betet
            für sie, meine Kinder betet. <br />
            AmenAmen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12. Februar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Richtet Eure Blicke auf die Heilige Eucharistie. Quelle fruchtbaren
            Lebens und ewiger Gesundheit. Kennet Euren Gott der in jedem
            Allereiligsten der Welt gegewärtig ist. Betet inniglich vor Jesus
            Eucharistie. Begebet Euch in Seine Hände mit Ehrlichkeit, damit
            damit
            <strong>Jesus der alle Liebe ist</strong>, Euch bekehren kann.
            Bleibt bescheiden und respektvoll in seiner Gegenwart¡ er ist Gott!
            Predigt dieses. <br />
            Amen Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Februar 1996</h6>
          <p>
            Kommet meine Kinder zu meinem unbefleckten Herzen. Dieses Herz wird
            Eure Festung sein, ich werde Euch immer beschützen,” Ich widme mein
            Unbeflecktes Herz voller Liebe für Euch”. <br />
            Amen. Halleluya. Amen.Alleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14. Februar 1996</h6>
          <p>
            Meine Kinder, ich bin volller Trauer weil ihr die Konsequenzen
            dieser Zeil in welcher wir leben erleidet, die meisten versuchen die
            Probleme entfernt von Gott zu lösen. Es ist Zeit der Barmherzigkeit
            ich bitte Euch Eure Liebe zu verinnigen. Offnet Eure Herzen der
            Liebe zu Jesus Christus Er wird Euch erhören und die Dunkelheit wird
            von Euch weichen, Eure Seelen werden sich öffnen um den Geist Gottes
            und die Göttliche Weisheit wird Eure Ratgeberin sein. Wenn ihr frei
            sein wollt, befreundet Euch schnellsten mit Gott. <br />
            Ich liebe Euch alle, Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16. Februar 1996</h6>
          <p>
            Meine geliebten Kinder: <br />
            Ich möchte, dass Ihr begreifr wie gross die Liebe des Vaters im
            Himmel ist. Einige von Euch leben in vollkommener Dunkelheit, aber
            durch die Barmherzigkeit Gottes, erhaltet ihr die Liebe Gottes
            gleich denen die im Lichte des Heiligen Geistes leben. <br />
            Meine Kinder ich bin gekommen um Euch HOFFNUNG zu bringen, so werden
            die die im Düsteren laufen erleuchtet werden. <br />
            Lebet nicht dieUnzüchtigungen dieser Welt, als wenn dies das lezte
            Ziel wäre. Sehet alles unter dem Lichte des Glaubens mit den Worten
            die Jesus Euch hinterlassen hat, er hat gelitten damit ihr stark
            bleibt auf dem wege zum Himmel. <br />
            ¡Bekehret Euch Alle! Damit ihr die Welt erleuchtet, und in Eurem
            Herzen das Göttliche Herz meines Sohnen Jesus sich widespiegelt.
            <br />
            ¡Glorie sei Gott! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. Februar 1996</h6>
          <p>
            Be tet dem Herrn den <strong>Heiligen Rosenkranz</strong> und bittet
            um Gottes Schutz , beim beten diesesGebetes welches mächtig ist,
            werdet ihr in Euren Leben die Kraft und das Licht des Heiligen
            Geistes empfangen. <strong>Der Heilige Rosenkranz</strong>ist die
            schönste Zierde der Seele, richtet Euch jederzeit zu ihm. <br />
            Ich bin in dem Heiligen Rosenkranz, als Tochter Gottes,
            Muttergottes, Gemahlin von Gott und Eure Euch liebende Mutter.{" "}
            <br />
            ¡Ich liebe Euch meine Kinder! Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. Februar 1996</h6>
          <p>
            Im Gebet seid ihr mit dem Vater, dem Sohne und dem Heiligen Geist
            vereint.Wenn mit dem Gebet die Türe Eures Herzens der unendlichen
            Liebe Gottes geöffnet bleibt, werdet ihr unendliche Gnaden erhalten.
            <br />
            Amen Aleluya Amen Aleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>23. Februar 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Kommet der unendlichen Liebe des “Eucharistischen Herzen Jesu
            “näher.
            <br />
            Dieses sind Zeiten der Vorbereitung. Verliert keine Zeit mit
            unnötigen Dingen dieser Welt, machet Euch schnellsten frei von jedem
            bösen Geist. <br />
            Erhört meine Botschaften mit dem Geiste der Überlegung, ich spreche
            zu Euch geliebte Kinder damit ihr im Geiste wachst, seid gütig und
            barmherzig, vertraut in die unendliche Güte des Herrn, damit ihr mit
            seiner Gnade unentwegt immer wie gute Christen handelt”Wendet Eure
            Augen zu Jesus Christus”. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. März 1996</h6>
          <p>
            Die Mutter sagt: <br />
            “Ich bin die Glorie dieses Volkes”
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. März 1996</h6>
          <p>
            Meine Kinder: Dass sich in Euch die Liebe des Vaters, das Opfer des
            Sohnes und die Hoffnung des Heiligen Geistes erzeuge. <br />
            Bringet Euch der Allerheiligsten Dreifaltigkeit dar.Geniesset die
            Güter dies Erde als etwas unwichtiges und vorübergehendes und danket
            seiner unendlichen Grosszügigkeit die er Euch dargibt. <br />
            In dieser Zeit der Vorbereitung bedenket das Wort des Herrn mit
            tiefer Bescheidenheit damit ihr im Himmel von Eurem Vater angenommen
            werdet der Eure Herzen kennet. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. März 1996</h6>
          <p>
            Meine geliebten Kinder: <br />
            Durch die Liebe Gottes seid Ihr in dieser Welt. <br />
            Folget dem Herrn und bekehret Euch in diesen Zeiten von grosser
            Barmherzigkeit. <br />
            Öffnet die Augen dem Lichte der Welt, dem Erlöser. <br />
            Es werden Zeiten kommen in denen Ihr gerichtet werdet und danach
            wird es grosse Abgründe zwischen dem Guten und dem Bösen geben.{" "}
            <br />
            Meine Kinder der Himmel erwarte Euch alle. Kommet zu meinem
            Unbefleckten Herzen. <br />
            Ich führe Euch zu Gott. Ich liebe Euch inniglich. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. März 1996</h6>
          <p>
            Der Friede und die Liebe des Herrn sei mit Euch geliebte Kinder.
            <br />
            Heute bin ich gekommen um Euch zu bitten dass ihr im Gebete vereint
            bleibt. Somit werdet ihr den boshaften Feind bekämpf, welcher unter
            allen Mitteln Euch den Frieden nehmen will, besonders den Frieden in
            den Heimen, indem er Unruhe und Angst ausbreitet um Euch von der
            Liebe Gottes zu entfernen. <br />
            Betet auf den Strassen den Heiligen Rosenkranz um das unbefleckte
            Herz von Maria zu entschädigen. Der Rosenkranz ist Euer
            Rettungsbrett. <br />
            Betet mit Kraft die einen für die Anderen und lasst Eure Liebe in
            Euren Herzen aufflammen für den leidenden Bruder. <br />
            Wendet all Eure Hoffnung dem<strong>Herrn</strong>zu. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. März 1996</h6>
          <p>
            Meine Kinderlein: <br />
            Bleibet achtsam in Eurer Liebe zu Gott. <br />
            Heute bin ich gekommen um euch zu sagen, was der Herr von seinem
            Volke will. Seid ihm treue Kinder. Und wisset dass ein jeder ein
            wirklicher Christ sein muss. <br />
            Segnet den Vater, welcher mit seiner unendlichen Grosszügigkeit mit
            Euch gütig ist. Höret die Worte des Herrn, es sind die Worte des
            Ewigen Lebens, und handelt so um nicht zu stolpern. <br />
            Solche die den geraden Weg des Herrn abweichen, schleppen schwere
            Ketten mit sich und es leuchtet kein Licht in ihren Herzen. Wachset
            meine Kinder in seiner Heiligen Weisheit und ihr werden mit Eurem
            Gott vereint sein. Predigt dieses. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. März 1996</h6>
          <p>
            “Bringet Euch dem
            <strong>, Allerheiligsten Eucharistischen Herzen Jesu</strong>dar”
            es ist ein dringender Ruf der Liebe Gottes. Seid gehorsam mieine
            Kinder “Ich bin die Mutter Gottes” Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. März 1996</h6>
          <p>
            Dass sich in Euch der Wille Gottes erfülle “Seid Heilig”. <br />
            Betet um diese Fürbitte.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. März 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Hebet Eure Augen zum Himmel und bittet dem Herrn in seiner
            Göttlichen Barmherzigkeit dass er Euch reuevolle Herzen gebe. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. März 1996</h6>
          <p>
            ¡Werdet nicht schwach! Das Eure Knie sich nicht vor dem Geiste des
            bösen neigen. Der Herr bittet Euch um Bekehrung. Fastet und macht
            Busse. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. März 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Sei jeder für sein Gewissen verantwortlich, damit ihr in der Fülle
            der wirklichen Freiheit die Gott Euch gab leben könnt Lebet das
            Evangelium gemäss der Liebe. Helfet einer dem anderen in der Liebe
            so wird jeder das Notwendige erhalten und ihr werdet nicht verloren
            gehen. Betet meine Kinder mit dieser Absicht Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. März 1996</h6>
          <p>
            Ihr seid alle berufen Euch in Liebe mit Gott Eurem Vater zu treffen,
            predigt dieses. <br />
            Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14. März 1996</h6>
          <p>
            Meine Kinder: <br />
            Ich ermahne Euch die Wunder Gottes Schöpfung zu beschauen, mit der
            Seele und all Eurem Wesen. Segnet und verehrt seinen Heiligen Namen,
            alles schuf er seiner unendlichen<strong>Liebe</strong>. <br />
            ¡Habet Reue! <br />
            Wendet Eure Herde zu Gott und ihr werded leben. <br />
            Amen Amen Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. März 1996</h6>
          <p>
            Ehret das Allerheiligste Sakrament, ehret es mit dem Herzen, mit der
            Seele mit dem ganzen Wesen. Bittet mit Vertrauen meine geliebten
            Kinder und so wird Euch alles gegeben um würdige Kinder Gottes zu
            sein. <br /> Lebet euer Leben mit Ihm der unendliche
            <strong>Liebe</strong>ist und in der Heiligen Eucharistie gegewärtig
            ist. <br />
            Nähert Euch seinem Tische und esset alle mit Ihm. <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18. März 1996</h6>
          <p>
            Geliebte Kin <br />
            Suchet nicht den materiellen Trost, suchet Eure Versöhnung im Gebet.
            <br />
            Betet mit Glauben mitten in den Schwierikeiten um den Herrn treu zu
            sein. <br />
            Lebet mit der Hoffnung in Eurem Herzen. Suchet Zuflucht in meinem
            Unbeflecktem Herzen und ihr werdetsiegen. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. März 1996</h6>
          <p>
            ¡Gelobet sei der Allmächtigste! <br />
            Meine Kinder : ich bitte Euch in dieser Zeit der Wandlung, über Eure
            Leben nachzudenken, im Licht der Evangelien, Worte des Lebens und
            der Heiligen Weiseit. <br />
            Schaut in Euer Gewissen und versöhnt Euch mit Gott. <br />
            Wendet Euren Geist mit echter Reue dem Herrn zu. <br />
            Öffnet Eure Herzen dem Allerheiligsten Eucharistischen Herzen Jesu!
            <br />
            Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21. März 1996</h6>
          <p>
            Heute hatte ich eine Vision von Jesus im Gebet. Es ist Nachts und es
            gibt viele Sterne am Himmel <br />
            Eine Stimme sagte mir:! Er kennt seine Schafe! Ich verstehe dies mit
            meinem Herzen. <br />
            Der Herr kennt alle seine Schafe und ein Jedes, in der Zeit und
            Umständen. <br />
            Der gute Hirte ist unsere Hoffnung. ER sucht uns, er kennt uns und
            sieht uns seit der Ewigkeit.”Er ruft uns”. Wer ihn erhört nähert
            sich seinem Geist der<strong>Liebe</strong>und er weilet unter uns
            mit seiner Liebe. Gebet Erlösende Seele Jesus Christus, verzehre
            meine Seele bis zum letzen Tropfen meines <br />
            Verlangens nach mir selbst und fülle sie mit der innigen Sehnsucht
            Deiner Liebe zu den Seelen. Das die Tropfen Deines erlösenden Blutes
            in meine Herz fallen, es umwandeln und Deinem Heiligen Herzen
            zuwenden. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. März 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Heute komme ich Euch zu besuchen mit der Absicht Euch Jesus, meinen
            geliebten Sohn, näher zu bringen. Erhöret meine Worte und erfüllet
            sie vollständig und gewissen- haft, eröffnet mir Eure Herzen damit
            das Licht des Heiligen Geistes Euch durchdringe und somit ihr JESUS
            CHRISTUS Euren Erlöser kennen lernt. <br />
            Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27. März 1996</h6>
          <p>
            Wenn ihr eine Welt voller Liebe wünscht.”
            <strong>LIEBET GOTT ÚBER ALLE DINGE”</strong>. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. April 1996</h6>
          <p>
            Maria meine Tochter¨: <br />
            Du sollst alle diese Prüfungen mit grosser Liebe zum gekreutzigten
            Christus durch- stehen. Die Gnade Gottes wird Dich begleiten <br />
            Die reichlichen Früchte Deines Herzens werden den notleidenden
            Seelen gegeben, wenn Du im Gebete bist. <br />
            Amen .Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. April 1996</h6>
          <p>
            Meine Tochter: <br />
            Erhebe Dein Herz zum Kreuz meines SOHNES um das ganze Mysterium
            seiner Liebe zu verstehen. <br />
            Verweile am Kreuz bei Jesus so wird Dein Herz voller Gnaden sein.
            <br />
            Dies ist Gottes Versprechen. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. April 1996</h6>
          <p>
            JESUS sagt : <br />
            Betrachtet mich und betet mich im Allerheiligsten Eucharistischen
            Herzen an. Ihr seid in MIR, wenn ihr meinen Heiligen Körper esset
            und mein Heiliges Blut trinket und meine unendliche LIEBE wird in
            Euch sein: <br />
            Allerheiligste Maria sagt: <br />
            In der Wunder der HEILIGEN EUCHARISTIE, werdet ihr von der
            Intyensität des DREIFALTIGEN LICHTES durchdrungen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. April 1996</h6>
          <p>
            Meine Tochter: <br />
            Dem Mysterium des Kreuzes sich hingeben ist Umwandlung. Wenn wir das
            Kreuz aus Liebe zu Jesus umarmen, verwandeln wir das Bittere in
            Süss, den Schmerz in Freude, Verzweiflung in Frieden, Hass in Liebe.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. April 1996</h6>
          <p>
            Am Fusse des Kreuzes in grausamer Agonie, erhielt die schmerzende
            Mutter Gottes Glorie als Sie Ihr Herz eröffnete.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. April 1996 (Sonntag der Auferstehung)</h6>
          <p>
            ¡Glorie der Macht Gottes ! <br />
            ¡Glorie dem Heiligen Geiste! <br />
            ¡Erfreuet Euch und erheitert Euch in der Auferstehung des Herrn!
            <br />
            ¡Ehre sei Gott! <br />
            ¡Ehre sei Gott! <br />
            ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. April 1996</h6>
          <p>
            Meine Kinder: <br />
            ¡Bekehrer Euch! fortdauernd, seid Strahlen von Jesus, so werden die
            Euch sehen in Euch wirkliche Christen erkennen. <br />
            Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. April 1996</h6>
          <p>
            Nähret Euch fortdauernd mit Gottes Wort, und versucht immer seinen
            Willen zu erfüllen. <br />
            Alle Zeit die Ihr nicht Eure Augen zum Himmel wendet, ist verlorene
            Zeit. <br />
            Amen. Halleluya. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10. April 1996</h6>
          <p>
            Arbeitet mit Freude meine Kinder, auf den Feldern des Herrn, denn es
            werden Zeiten kommen in denen ihr das gesähte sammeln werdet. <br />
            Seit bescheiden und beständig in der Bitte um die
            <strong>Gnade</strong>Gottes. <br />
            Halleluya. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. April 1996</h6>
          <p>
            (Heute sah ich die Allerheiligste Jungfrau in tiefer Traurigkeit und
            Bedrängnis, voll- kommen in weiss gekleidet und ihr perfektes
            Gesicht schien in Schweiss gebadedt.) <br />
            Meine Kinder: <br />
            Heute komme ich mit der Bitte dass ihr mit grosser
            <strong>Dringlichkeit</strong>um den Frieden der Welt betet und
            betet. Denn dieser ist ernshaft bedroht wegen der Gemeinheit des
            entzetzlichen Feindes Gottes. <br />
            Vertraut meinem unbeflecktem Herzen, es wird Euch inmitten
            fürchterlicer Folterungen leiten. Ich werde Eure Ratgeberin sein,
            wendet Euch nicht von meinem Weg und von dem heiligen Rosenkranz,
            betet ihn andauernd. Ich bin Eure Mutter und spreche zu Euch wie
            Eure Mutter. <br />
            Die heutige Botschaft ist sehr grausam und schwierig zu verstehen,
            für jene die vergessen dass Gott existiert, und sogar für jene die
            an Gott glauben ist aber nicht versuchen ihre Seele zu retten und
            für das Fleisch und die Welt leben. <br />
            Fürchterliche Dinge erwarten Euch meine Kinder wenn ihr Eure Augen
            icht Gott zu- wendet, denn die entzetzliche Strafe die Gott der Welt
            sendet wird beginnen. <br />
            Einen Teil werde ich Euch enthüllen um Euch zum Gebet und Opfer zu
            führen. Mit der Hoffnung dass Eure Gebete diese mächtige Strafe
            mildert . <br />
            Dies ist ein Hinweis für die Menschheit voll der LIEBE GOTTES.{" "}
            <br />
            Viele Seelen der Gottesgeweihten werden fallen und werden sich des
            Weges des Herrn abwenden, um in der Lauheit de Welt zu leben. Die
            restlien Priester werden sich nicht von den Laien unterscheiden, sie
            werden den Weg der Welt gehen und in der Apostasie enden. Viele
            Nonnen werden den gleichen Weg einschlagen und viele gute Seelen
            werden durch sie verloren gehen. Eine Welt ohne Religion und ohne
            Gott wird die Stätte von wilden tierischen Wesen sein, und die
            menschliche Phisionomie wird sich ändern, der Körper wird ein
            Widerschein der Seele sein. <br />
            Diese entsetzlichen Menschen werden Schüler des Teufels sein.Sie
            nutzen den Chaos welcher über die Menschheit kommen wird und werden
            die Guten in fürchter- licher Jagd verfolgen. Es wird keine
            unterschiedlichen Geschlechter geben und für eine von Gott erwählte
            Zeit wird die Hölle auf Erden sein. <br />
            Mein UNBEFLECKTES HERZ wird die Finsternis und und das Grauen von
            den mir Geweihten abwenden. Der Herr wird bis zuletzt auf eine
            Umwandlung zu meinem UNBEFLECKTEM HERZEN warten , damit alle eine
            Möglicheit habe sich zu retten. <br />
            Die Verebung Gottes ist UNENDLICH BARMHERZIG. <br />
            Betet, Betet mit zunehmender Liebe. <br />
            “Allerheiligstes Eucharistisches Herz Jesu in Dich vertraue ich”.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 19. April 1996</h6>
          <p>
            Suchet nicht Eure Heilung in den weltlichen Dingen. <br />
            ¡Haltet Euch an den heiligen Rosenkranz! <br />
            Der Rosenkranz wurde Euch zum Trost und Freude gegeben. <br />
            Gott sieht mit Freude wenn ihr diese bescheidene Andacht ausübt.
            <br />
            Amen . Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. April 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bin gekommen um Euch den Weg der Liebe zu zeigen, es ist Jesús.
            <br />
            Es ist der Weg der Wahrheit, das Leben. Wer ihn wirklich liebet wird
            nicht stolpern. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. April 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Glaubet an Gott und fürchtet nichts. <br />
            Nehmet hin mit Liebe alles was Er Euch sendet. <br />
            Ihr habt das Leben dank seiner Unendlichen Güte und seines Heiligen
            Willens, Und dieses Leben wird sich bis in die Ewigkeit velängern,
            wenn ihr Gott über alles liebt. Nichts wurde von Gott umsonst
            geschaffen doch die Sachen dieser Welt sind vergänglich. <br />
            DIE UNENDLICHE LIEBE GOTTES in Euch dehnt sich aus, reinigt Euch von
            Euren Sünden, ¡Bald! <br />
            Gehet in die Heilige Kirche und suchet meinen Göttlichen Sohn
            <strong>Jesus</strong>und ihr werdet Ihn finden. <br />
            ¡ Ach! Meine Kinderlein, Ihr könnt noch nicht verstehen wie viel
            Gott euch liebt. br Wenn ihr seine LIEBE kennet, würdet ihr vor
            Seligkeit sterben. <br />
            ¡Lernet! Meine Kinderlein und gebet Eurem Herzen Frieden. <br />
            ¡Wandelt euch bald! <br />
            Ich liebe und segne Euch alle. <br />
            Amen. Ame. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>30. April 1996</h6>
          <p>
            Meine Kinder: <br />
            Ihr habt in dieser Zeit eine grosse Veratwortung, dies ist für den
            Frieden und die Liebe der Menschen der Welt zu beten. <br />
            Wenn ihr einander lieber wird es Frieden geben. <br />
            Ihr werdet wirklich lieben wenn ihr Euch dem Gebete hingebt, noch
            mehr wenn ih aus Eurem Leben ei Gebet dem Herrn macht. <br />
            Widersagt allem Überfluss und sündigt nicht. <br />
            Öffnet Eure Herzen demWorte Gottes und lasset Euch leiten. <br />
            Erkennet Gott meine Kinderlein, wen ihr vor JESUS EUCHARISTIE kniet,
            und lasset Euch durch Ihn erlösen. <br />
            ¡Wie sehr liebet Euch Jesus! Seid gesegnet meine Kinder. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. Mai 1996</h6>
          <p>
            ¿Was kann Euch bedrücken meine Kinder? <br />
            Ihr habt “die Unendliche Liebe Gottes” zu Eurer Verfügung. <br />
            Wandelt Euch in Wirklichkeit und nicts wird Euch fehlen. <br />
            ¡Betet zum Himmel mit Beständigkeit! <br />
            ¡Seid Anhänger von Jesus! <br />
            Amen. Halleluya. Amen. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Mai 1996</h6>
          <p>
            (Die Allerheiligste Mutter Maria sagt) “Ich bin Eure Mutter und
            Beschützerin”. <br />
            Meine Aufgabe ist Euch der<strong>Liebe Jesus</strong>zu nähern.
            <br />
            Ich möchte alle meine Kinder nah meines Herzens haben. <br />
            Betet mit Glauben und Hoffnung zu Eurem Gott. <br />
            Ich liebe Euch alle. <br />
            Amen. Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 13. Mai 1996</h6>
          <p>
            Heute habe ich folgende Vision gehabt. <br />
            Ich sah eine Monstranz mit dem Allerheiligsten Sakrament, dort waren
            inmitten eines grossen Lichtes, viele Engel kniend in Anbetung die
            sie vollkommen umkreisten, zu Füssen lag ein Rosenkanz. Nach dieser
            Vision sah ich die Heiligste Jungfrau ganz in weiss gekleidet. Sie
            war inmitten eines strahlenden Lichtes welches ihr immer vor-
            angeht. Auf ihrem Kopfe war eine goldene Krone, ihe Hande gefaltet
            auf der Höhe der Brust, in ihrer Händen eine Rosenkranz der aus Gold
            schien. Ihr Blick war nach unten gewendet und sie sagte: <br />
            “Ich bin die Königin des Heiligen Rosenkranzes” ich bitte um
            Gebete,Opfer und Busse damit zu Euch der Frieden und die
            Barmherzigkeit Gottes komme. <br />
            Betet Jesus Euren Gott an, sowie die zahlreichen Engel im Himmel ihn
            anbeten. <br />
            Betet den Heiligen Rosenkranz jeden Tag, in Versöhnung der
            Beschmähungen und Sakrilegen mit denen das Allerheilgste
            Eucharistische Herz Jesu und das Unbefleckte Herz Marias beleidigt
            werden. <br />
            Betet mit dem Herzen damit alle geistig geheilt werden. <br />
            Die unendliche LIEBE GOTTES wird Euch meinen Kindern dargegeben.
            <br />
            Erhöret meine Wünsche und wandelt Euch bald ( sie öffnete Ihre Hände
            und gab den Segen) Ich segne Euch alle. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. Mai 1996</h6>
          <p>
            Meine Kinder: <br />
            ¡Rufet den Namen des Herrn an! Geht nicht der verkehrten Weg, nähert
            Euch der Wahreit des Evangeliums, der Weg zum ewigen Leben. <br />
            Betet damit Eure Herzen voller Wonne und Hoffnung sein und gesegnet
            durch die Liebe des Heiligen Geistes. <br />
            Während ihr betet, meine Kinder, ist der Herr beständig vor Euch
            damit ihr nicht Wanked. <br />
            ¡ Ehret die Glorie des Herrn! <br />
            Halleluya. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 16. Mai 1996</h6>
          <p>
            Gebenedeit die Kinder die nach der Liebe des Heiligen Geistes
            handeln, sie werden alles Böse besiegen. <br />
            Harret im Gebete und bittet dass das Licht des Herrn nicht von Euch
            weiche. <br />
            ¡Wendet Euch der Liebe des HEILIEGN GEISTES zu! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. Mai 1996</h6>
          <p>
            Gelobet sei der Herr in seiner unendlichen Glorie! <br />
            Gelobet sei seine Liebe die uns den Himmel brachte! <br />
            Und gelobet seien meine Kinder da sie Kinder Gottes sind. <br />
            Amen.Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20. Mai 1996</h6>
          <p>
            Gebet Gott Dank, meine geliebten Kinder, für alles was ihr von Ihm
            erhalten habt, vertrauet seiner Güte und Barmherzigkeit und betet
            allezeit in seinem Vertrauen. <br />
            Er wird Euch alle erhören. <br />
            Seid treu dem Herrn Er wird Euch trösten und mit seinem Geiste
            stärken. <br />
            Amen.Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22. Mai 1996</h6>
          <p>
            Meine Kinder, gebet Euch dem Herrn mir grosszügigem Herzen, Eure
            Hingabe soll nicht gemindert sein. <br />
            Der Herr kennt alles von Euch und wird Euch gemäss Euren Werken
            belohnen. Bittet dem Herrn, Heilig zu sein. <br />
            Danket dem Herrn und segnet seinen HEILIGEN GEIST. <br />
            Gelobet sei Er.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. Mai 1996</h6>
          <p>
            Jesus sagt zu mir: <br />
            Ich möchte erhört werden. <br />
            Ich befehle es Dir Sprich der Menschheit von meinem ”Allerheiligsten
            Eucharistischem Herzen”. <br />
            Dass alle sich meiner Unendlichen Liebe mit Vertrauen nähern. <br />
            Die Allerheiligste Mutter sagt: <br />
            Wendet Eure Augen zu Jesus Eucharistie, genähret mit der Liebe
            seines Allerhei- ligsten Herzen, erhöret und liebet Euren Gott.{" "}
            <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. Mai 1996</h6>
          <p>
            ¡¡Gesegnet seid meine Kinder!! <br />
            Heute bin ich gekommen um Euch den Segen und die Liebe des
            <strong>Vaters,</strong>des<strong>Sohnes</strong>und des
            <strong>Heiligen Geistes</strong>zi bringen damit alle sich wandeln.
            <br />
            Ich werde Euch auf dem Wege der Reinigung begleiten und werde das
            Licht sein dass Eure Schritte leitet. <br />
            Weihet Euch dem
            <strong>Göttlichen Eucharistischen Herzen Jesus</strong>und dem
            Unbefleckten Herzen Marias, dann werdet ihr das Licht in Euren
            Herzen leuchten sehen. <br />
            Die Türe ist geöffnet meine Kinder, kommet zu Mir und ich begleite
            Euch über die Schwelle. Dank dass ihrmicherhöret.Ich liebe Euch
            alle.
            <br />
            Amen. Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. Juni 1996</h6>
          <p>
            Heute hat die Mutter ihr Unbeflecktes Herz gezegt. Und sagt: <br />
            ¡Dies ist mein Unbeflecktes Herz! <br />
            ¡Nähert Euch alle Ihm! <br />
            In diesen Zeiten von grosen Prüfungen für die Menschheit, wird las
            Licht meines Herzens mitten in der Dunkelheit Leuchten. <br />
            Ich werde Euch nicht verlassen, sondern inmitten der Dunkelheit Euch
            mit Sicherheit führen. <br />
            Ich werde das Eis vieler mit der Wärme meiner Liebe brechen, und
            somit wedet ihr die die den Frieden Gottes erlangt habt, und von
            allen Schmutz und Götzen gereinigt seid, gerufen, um den Himmlischen
            Schmaus zu teilen, wie wirkliche Kinder Gottes. <br />
            Ich Liebe Euch alle. <br />
            ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. Juni 1996</h6>
          <p>
            ¡Fürchtet Euch nicht!, keine Kreatur soll sich von der Hand Gottes
            verlassen fühlen, sondern aufgemuntert werden{" "}
            <strong>robuste Christen</strong> in der Welt zu sein. <br />
            ¡Kämpfet! Ohne Angst, als Auserwählte Gottes, machet alles in seinem
            Namen mit Dank und lobet seine Liebe. <br />
            Ihr seid Kinder des Lichtes und für Eure Erlösung bestimmt. <br />
            Predigt Gottes wort und betet mit Ausdauer. <br />
            Amen.Amen.Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. Jni 1996</h6>
          <p>
            Tochter: <br />
            Mein Göttlicher Sohn Jesus möchte auf der ganzen Welt angebetet,
            gelobt und geseg- net werden in seinem Allerheilgsten,
            Eucharistischem Herzen. <br />
            Das alle den Willen des Allmächtigen kennen. <br />
            Amen.Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. Juni 1996</h6>
          <p>
            Meinen Jungen Kinderlein die von der Liebe des Herrn sich abgewendet
            haben sage Ich: ¡Öffnet Eure Herzen! <br />
            Lasset Euch nicht vom Geiste dieser Welt besudeln, sondern ergötzet
            Euch in der Güte des Herrn. <br />
            Erhebet Eure Augen zum Himmel und betet mit dem Herzen dem Schöpfer
            aller Wunderwerke seiner Kreation und seid gewiss von seiner
            Allmächtigkeit die Euch trägt in seiner unendlichen Liebe. <br />
            Fühlet immer seine Heilige Gegenwart in Euren Herzen. <br />
            ¡Gesegnet seid meine Geliebten! <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. Juni 1996</h6>
          <p>
            Allerheiligste Maria sagt: <br />
            An diesem so wichtigem Tag sollt ihr in andauerdem Gebet bleiben,
            erhebt Eeure <br />
            Herzen dem Heiligen Geist Gottes und so könnt ihr die Grösse des
            Allerheiligsten
            <strong>Sakramentes</strong>wahrnehmen. <br />
            Das groste Wunder der Liebe Gottes. <br />
            Gelobet sei Gott wegen seiner grossen Barmherzigkeit. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14. Juni 1996</h6>
          <p>
            ¡Gelobet sei der Herr!, in seinem Heiligen Herzen. <br />
            Geliebte Kinder ich bitte Euch mit grosser Ehrehaftigkeit euer Leben
            zu betrachten und tief in Eure Herzen schauen. <br />
            Dies ist die Zeit der<strong>
              Liebe und der Barmherzigkeit
            </strong>{" "}
            die ohne Mass aus dem Gött- lichen Herzen fliesset, ihr eid alle
            berufen. <br />
            ¡Öffnet Eure Seelen! <br />
            Das Göttliche Herz erwartet Euch, verzögert Euch nicht. <br />
            Ich liebe und segne Euch. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. Juni 1996</h6>
          <p>
            Meine Kinder reinigt Eure Gedanken, betrachtet immer seinWort.{" "}
            <br />
            Wer so handelt wird das Licht des Heiligen Geistes in seinem Herzen
            tragen. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18. Juni 1996</h6>
          <p>
            Wer<strong>Gott</strong>in seinm Herzen trägt, hat alles, weil nur
            <strong>Gott</strong>alles kann. <br /> Betrachtet dies meine
            Kinder. <br />
            Amen. Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21. Juni 1996</h6>
          <p>
            Fürchte Dich nicht meine Tochter, ich habe mein Vertrauen auf Dich
            gesetzt, ich Habe meine Hand in Deine gelegt. <br />
            Predigt mit Ehrlichkeit und Bescheidenheit was ihr erhalten habt,
            füget nichts hinzu und mindert nichts was Gott von Euch verlangt.{" "}
            <br />
            Weihet Euch alle dem Alleheiligsten Eucharistischen Herzen Jesu.{" "}
            <br />
            Betet und betrachtet meine Mitteilungen und setzet all Eure Hoffnung
            auf den Herrn. <br />
            Viele sind ungläubig, aber Gottes Kraft wird Euch nicht verlassen,
            die Anstrengung wird gross sein. <br />
            Meine Nähe ist für alle eine grosse Gnade Gottes. <br />
            Ihr seid begünstigt. Das es viele Nutzen gebe.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. Juni 1996</h6>
          <p>
            Maria Tochter: So wie Du mich siehst und hörst, so nah bin ich bei
            meinen Kindern, gebt dies bekannt, dass alle sich nähern, und meinem
            Herzen vertrauen. ¡Glorie dem Allmächtigen! Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. Juni 1996</h6>
          <p>
            Maria siehe achtsam auf mein Antlitz, heute ist es ein Wiederschein
            der Freude die im Himmel herrscht, viele Herzen weden wieder mit
            Liebe schlagen. Verbreite dies. Ich bin die Mutter der Hoffnung Ich
            gewähre sie wer um sie bittet Dem der sie Sucht. Dem der sie kennt.
            Ich bin der Weg zur Hoffnung er ist Jesus. ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. Juni 1996</h6>
          <p>
            Seid in Fülle gesegnet, im Alleheiligsten Eucharistischen Herzen
            Jesus. Gesegnet werden Deine Werke, gesegnet werden die Personen die
            um dich sind. Gesegnet sei mein Göttlicher Sohn in seinem Heiligen
            Versprechen. ¡Glorie Jesus! ¡Heilig, Heilig, Heilig!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29 Juni 1996 </h6>
          <p>
            Heute sage ich meinen Kindern Liebet inniglich die Heilige Kirche,
            betet für den Heiligen Vater, täglich in meinem Herzen vereint.
            Verbreitet das Word und lebet es mit absoluter Hingabe. Lebet für
            Jesus Chistus mit ihm und in ihm. Einet Euch dem Herzen Jesus Amen.
            Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. Juli 1996</h6>
          <p>
            Gelobt und gebenedeit sei Gott in all seinen Kreaturen. Amen. Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. Juli 1996 </h6>
          <p>
            ¡Gesegnet seien meine Kinder! ¡Gesegnet seien die Solidarischen und
            Verständnisvollen! ¡Gesegnet seien die dem Allerheiligsten
            Eucharistischen Herzen meines Göttlichen Sohnes treu sind! ¡Ehre dem
            Herrn!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9. Juli 1996</h6>
          <p>
            Fürchtet Euch nicht meine Kinder. Ich bin bei Euch bin Quelle des
            Lichts und der Liebe. Ich habe die Finsternis mit dem Licht meines
            Herzens vetrieben, damit ihr euch nicht verwirret in diesen Zeiten
            schwerer Fehler, gehet an meiner Hand für eine dringende Wandlung.
            Betet. Betet. Betet, und fastet zweimal in der Woche. Predigt und
            lebet meine Botschaften und ihr werdet grosse Dinge in Euch und in
            Euren Familien sehen. ¡Seit gehorsam meine Kinder! Verstehet dieses
            gut. Ich liebe Euch und segne Euch. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Juli 1996</h6>
          <p>
            ¡Gelobet sei der Herr in all seinen Kreaturen. ¡Gelobet sei der
            Himmel und die Erde! ¡Seiet reichlich gesegnet meine Kinder! ¡Seien
            gesegnet eure Priester im Allerheiligsten Eucharistischen Herzen
            Jesus! Glorie, Ehre und Anbetung dem Eucharistischen Herzen meines
            Göttlichen Sohnes. Amen. Halleluya.Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16. Juli 1996</h6>
          <p>
            ¡<strong>Gesegnet seien meine</strong>Kinder!
            <br />
            Danke für die Liebe in euren Herzen.ich wünsche das ihr die Liebe
            Jesus mit
            <br />
            einem bescheidenen Herzen lebet und so wird das starke Licht seines
            Herzens euch
            <br />
            begnaden und euch viele Nutzen bringen. Erfreuet Euch und danket dem
            Herrn, denn er hat euch gesehen und unter vielen aus-
            <br />
            gesucht zur Glorie und Lob seines Heilien Herzenz, gegenwärtig in
            der Heiligen
            <br />
            Eucharistie. <br />
            Seid gesegnet. Gesegnet werdet ihr sein.
            <br />
            Predigt dies. <br />
            Amen. Halleluya. Amen. Halleluya. <br />
            Geliebte Kinder: <br />
            Heute sende ich euch den Frieden meines Herzens, der euch den Weg
            zur Umwandlung zeigt. Ich segne Euch mit mit dem Frieden und der
            Liebe meines Unbefleckten Herzens. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 Juli 1996</h6>
          <p>
            ¡Glorie dem Allerhöchsten! ¡Gelobet sei der Herr! Geliebte Kinder.
            Ich werde euch zu dem Herrn führen. Tage voller Glück erwarten Euch
            Die in meine Worde vertrauet. Gesegnet seien alle meine Kinder.
            Amen. Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29. Juli 1996</h6>
          <p>
            Geliebte Kinder: ¡Segnet der Herrn! Segnet ihn mit Euren Herzen
            voller Liebe zu IHM. ¡Gehorchet dem Herrn! Gehorchett IHM mit Euren
            Herzen voller Liebe zu IHM! ¡Segnet den Herrn! Segnet ihn immer und
            danked IHM für seine LIEBE. Betet seinen Heiligen Willen an und so
            werdet ihr empfinden das der Geist Gottes bei Euch bleibt <br />
            Amen. Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1. August 1996</h6>
          <p>
            ¡Betet Gott an! Betet nur Gott an und schauet zum Himmel, wo die
            Heiligste Dreifaltigkeit ist. Betet die
            <strong>HEILIGE EUCHARISTIE</strong>an, flehet und bittet bei seiner
            Heiligen Anwesenheit. Gott ist Liebe! Gott kann alles, weil seine
            Liebe unendlich ist. Seid gesegnet. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. August 1996</h6>
          <p>
            “¡Ich bin Eure Mutter im Himmel!” Ich bin im Himmel glorreich mit
            Körper und Seele. Meine Kinder heute bin ich besonders zu Euch
            gekommen an diesem Tage des Sieges meines unbefleckten Herzens
            welches für alle Ewigkeit mit der Heiligen Dreifaltigkeit herrschet.{" "}
            <br />
            ¡Ehre sei Gott!¡Gelobet sei die Glorie des Herrn! Segnet den Herrn,
            lobet seine Grösse. Weihet Eure Herzen dem{" "}
            <strong>Allerheiligsten Eucharistischen Herzen Jesu.</strong> <br />
            Das Meine Mitteilungen betrachtet werden, und nicht in einer
            Schublade abgelegt seien, leset, überlegt, und beginnet zum Heiligen
            Geist zu beten dam tsie in Euren Leben verwiklicht werden können.
            Das in Euch der Frieden Herrsche und die Liebe zu Jesus, ich segne
            Euch in hohem Masse. Amen. Halleluya. Amen. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. August 1996</h6>
          <p>
            Meine Kinder: Betet dem Heiligen Geist, bringet ihm jeden Tag Eure
            Werke dar. Wenn ihr betet, werdet ihr heilige Eingebungen erhalten
            für jede Tat. Seid gläubige Heilige. Richtige Tempel Jesus. Ich
            segne Euch alle. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18. August 1996</h6>
          <p>
            Geliebte Kinder: Suchet nich die unötige Weisheit der Welt, sonder
            das Licht, welches aus der Höhe kommt und ewiges Gotteswissen ist.
          </p>
          <p>
            Ihr habet Alles, Gott ist mit Euch in der “
            <strong>HEILIGEN EUCHARISTIE.”</strong>
            Bleibet im Gebet und lobet Euren <strong>Herrn</strong> als
            notbedürftige Kinder. Erfahret diese Gnade der Hoffnung. Ich liebe
            und segne Euch. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. August 1996</h6>
          <p>
            Meine Kinderlein: ¡Gesegnet sei Gott! ¡Kehret zurück zu den Wegen
            des Herrn! So werdet ihr mit Sicherheit in Gottes Reich gelangen.
            Ich bin Eure Mutter im Himmel ich liebe Euch. <br />
            Ich bin gekommen um Euch zu einem Leben des Gebetes zu rufen, um an
            den Dinge des Himmels Euch zu erfreuen. Beginnet mit mir zu beten in
            dieser Zeit von Hoffnung und Barmherzigkeit. <br />
            Lasset diesen Moment nicht vergebens vegehen. <br />
            ¡Ehre sei Gott!.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22 August 1996</h6>
          <p>
            Erhebet Euch meine Kinder. <br />
            Ich bin die Mutter Gottes, “Königin des Himmels und der Erde”!
            Weihet Euch alle dem Unbeleckten Herzen Marias und so werde ich
            Königin Eurer Herzen. <br />
            Ich werde Euch in Eurem Innern verwandeln, werde permanente
            Begleiterin in Euren Leben sein und das Licht von Christus wird in
            Euch Leuchten. <br />
            Achtet auf meine Worte damit der Samen Wachse und Früchte bringe.
            ¡Glorie dem Allmächtigen”!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. August 1996</h6>
          <p>
            Betet meine Kinder. Erhebet Eure Gebete zu Gott sobald der Tag
            beginnt. Suchet Schutz im Gebet. Emphelt Euch Jesus und empfehlt
            Eure Familien. Bittet um den Schutz Gottes für alle. <br />
            Seid gewiss dass der Boshaftige durch alle Mittel Euch von Gott
            abwenden wird, In der er Angst und Unmut in Eure Herzen tut. <br />
            Kräftigt Euren Glauben mit dem täglichen Gebet. <br />
            ¡Gelobet sei der Herr!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 August 1996</h6>
          <p>
            Ich liebe Euch meine Kinderlein und komme um Euch zu trösten wenn
            ihr mit Vertrauen zu mir kommt. Ihr habt ein mächtiges Mittel zu
            meinem Herzen zu gelangen, es ist das Gebet des Heiligen
            Rosenkranzes. Wenn ihr diese angenehme Devotion betet werdet ihr
            Gnade empfangen. <br />
            ¡Bittet meine Kinder! Bittet um die Bekehrung Eurer Herzen und alles
            Andere wird Euch gegeben. Ich segne Euch. <br />
            Amen. Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>30 August 1996</h6>
          <p>
            Meine Kinder: Seid wirkliche Christen, nehmet mit Gewissen diese
            Bedeutung. Öffnet das Heilige Evangelium und lernet die
            Barmherzigkeit des<strong> Herrn</strong> für Euch kennen. <br />
            Lasset den Heiligen Geist in Euren Herzen walten. Niemand erlöst
            sich selbst, sondern durch die unendlich grosse Barmherzigkeit
            Gottes.
          </p>
          <p>
            ¡Gelobet sei der Göttliche Sohn Gottes! ¡Sei er für immer gelobet!
            Ich segne Euch. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. September 1996</h6>
          <p>
            Kinderlein, die Nächstenliebe sei in Euren Herzen so notwendig wie
            das Wasser, welches Ihr trinkt. Predigt dieses. <br />
            ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3. September 1996</h6>
          <p>
            ¡Geehret sei der Herr! Seid beharrlich und bescheiden. <br />
            ¡Rufet den Herrn mit Ausdauer! Seid bereit Gutes zu tun und Böses zu
            vermeiden <br />
            ¡Vertraut dem Herrn! Er wird Euch beschützen, erhebet Eure Herzen,
            vereint Euch seinem Heiligen Herzen. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. September 1996</h6>
          <p>
            Wandelt Euch meine Kinder. Ich fordere Euch auf. Kehret zu Gott.{" "}
            <br />
            Es ist schon Zeit der Ernte. Heute seid ihr gesegnet. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. September 1996</h6>
          <p>
            Kinderlein. Entzündet Eure Herzen mit Liebe und betet
            ununterbrochen. Bringet Euer Fasten und Eure Opfer für den Frieden
            der Welt dar. Ich wünsche dass Ihr kleine Instrumente der Liebe für
            Gott seid. Erfüllet diese heiligen Bitten die ich euch mache. <br />
            Betet <strong>alle</strong> den Heiligen Rosenkranz, kniet in
            Bescheidenheit und ruft zum Himmel, damit der Friede und die Liebe
            Gottes auf der Erde walten. Wenn ihr mit ganzem Herzen betet wird
            der Friede in Euren Herzen einkehren, und in Euren Familien wird die
            Liebe Gottes sichtbar sein. <br />
            Fürchtet Euch nicht! Ich werde Euch bewachen und immer mit Euch
            beten. Ich bin die Mutter Gottes. Ich bin Eure Mutter. Seid
            gesegnet! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. September 1996</h6>
          <p>
            ¡Seid bescheiden meine Kinder! Bescheiden im Herzen. Fühlet Reue und
            beichtet Eure Schulden. ¡Eröffnet Eure Herzen! Gehet zum Treffen mit
            Jesus. Es gibt nichts herrlicheres als eine Seele in Gnade Gottes.{" "}
            <br />
            Jesus liebt Euch in seiner unendlichen Barmherzigkeit <br />
            ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. September 1996</h6>
          <p>
            Meine geliebten Kinder. An diesem Tag bin ich gekommen um Euch zu
            segnen und zu sagen dass mein Mutterherz sehr glücklich ist, weil
            viele von Euch mit mir gehen. <br />
            Ihr seid auserwählt in der Liebe Jesu zu wachsen zur Ehre und Lob
            seines Namens. Viele Schwierigkeiten erwarten Euch aber mit meiner
            Hilfe werdet Ihr alles können. Rufet den Namen des Herrn im Gebet
            und Ihr werdet seine Barmherzigkeit fühlen, die so mächtig ist wie
            ihr es Euch nie vorstellen könnt. Ich segne Euch alle. <br />
            Ich sah wie die Allerheiligste Mutter ihre rechte Hand mit dem
            Rosenkranz erhob sie segnete weitghend, schaute nach unten und
            lächelte zart.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 11 September 1996</h6>
          <p>
            Kinderlein: <br />
            ¡Seid wie Kinder! Damit der Heilige Geist in Euch walten kann. Seid
            gütevoll und barmherzig mit den leidenden. ¡Öffnet eure Herzen! Das
            die Nächstenliebe nimmer aufhöre, dass ihr immer in Liebe lebet, so
            werden ihr im Himmel gekannt <br /> ¡Gott ist unendliche LIEBE.!{" "}
            <br />
            Predigt dieses <br />
            Amen. Halleluya. Amen. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. September 1996</h6>
          <p>
            Heute während ich im Gebete war sah ich die Allerheiligst Jungfrau
            die in grosser Pracht mit Engeln vom Himmel herabkam, sie war in
            weiss gekleidet und ihr Umhang war hellbau, ihr Schleier weiss.{" "}
            <br />
            Ihre Hände waren gefaltet im Gebet und ein leichtes Lächeln war in
            ihrem wunder schönen Antlitz. <br />
            Meine Seele blieb erhoben in dieser ehrfurchtsvollen Vision Vor der
            Allerheiligsten Jungfrau erschien ein Stern der wie die Sonne
            glänzte. <br />
            Die Allerheiligste Jungfrau kniete in tiefem Angebet, später sah ich
            nur inmitten eines goldenen Lichtes die HEILIGE HOSTIE das verletzte
            Herz Jesu und eine Stimme der Allerheiligsten Jungfrau die sagte:{" "}
            <br />
            “Gesegnet und gebeneteit sei das Allerheiligste Eucharistische Herz
            Jesu” <br />
            “Gesegnet und gebeneteit sei das Allerheiligstre Eucharistische Herz
            Jesu” <br />
            “Gesegnet und gebenedeit sei das Allerheiligste Eucharistische Herz
            Jesu” <br />
            Danach sagte die Mutter: <br />
            “ Ich bin die Unbefleckte Mutter des Göttlichen Eucharistischen
            Herzen Jesus” <br />
            Ich frug sie: <br />
            ¿So willst Du genannt werden? <br />
            Und sie sagte: <br />
            “Ja, so werdet ihrmichkennen” <br />
            Sodann erhob sie ihre rechte Hand segnete weit und erhob sich.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. September 1996</h6>
          <p>
            “Der<strong>Herr</strong>sagt” <br />
            wenn ihr von mir sein wollt, kommet zu mir.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16. September 1996</h6>
          <p>
            Kinderlein: <br />
            Kümmert Euch nicht um die weltlichen Dinge, erfreut Euch an den
            Himmlischen. Amen. Amen.
          </p>
        </div>

        <h6>17. September 1996</h6>
        <p>
          Meine Kinder: Betet den Heiligen Rosenkranz mit Liebe Opfert ihn
          meinem Unbefleckten Herzen. <br />
          So werdet ihr weise in den Sachen Gottes, Werdetmicherkennen und auch
          Gott kennen. <br />
          “Ehre dem Allerhöchsten”
        </p>

        <div className="col-12 mt-5">
          <h6>18. September 1996</h6>
          <p>
            “Ehret den Herrn”. <br />
            Verharret im Gebet und in den guten Taten. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. September 1996 </h6>
          <p>
            Meine Kinderlein: <br />
            “Ich lade Euch ein dieses Fest mit Dank und Ehren zu Gott zu feiern.
            Ich bitte Euch Eure Herzen der Liebe zu öffnen. <br />
            Betet zum Heiligen Geist, damit er Euch Friede und Kraft in dieser
            Zeiten gebe. Ich bin die Mutter Jesu und bringe Euch
            <strong>Licht</strong>und Hoffnung. Seiet gesegnet meine Kinder"{" "}
            <br />
            Amen. Halleluya. Amen. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. September 1996</h6>
          <p>
            ¡Gesegnet seiet meine Kinder! ¡Gesegnet alle die mit dem
            Einverständnis Gottes Wort leben! <br />¡ Gesegnet die die Prüfungen
            in der Liebe zu seinem Namen bestehen! <br />
            ¡Gesegnet seien die den Prinz dieser Welt verabscheuen und dem Herrn
            treu sind! An diesem besonderem Tag ermuntere ich Euch meine Kinder
            in der Hoffnung, die JESUS ist, zu gehen. <br />
            Reinigt Eure Herzen und lebet wie wirkliche Kinder Gottes. Indem Ihr
            Gott in allen Dingen liebet. Ich werde immer bei Euch sein. Ich
            liebe Euch inniglich. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2. Oktober 1996</h6>
          <p>
            Meine Kinder: <br />
            "Ich werde ein Volk voller Liebe zu Gott wecken. Tuet immer das Gute
            und verachtet das Böse. <br /> Segnet immerfort den Namen Gottes Und
            segnet auch andere im Namen Gottes, so wird immer in Euch das Licht
            des Frieden leuchten und die Liebe des Herrn, die in der Heiligen
            Familie unter Euch ist." <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 3. Oktober 1996</h6>
          <p>
            Meine Kinderlein. Betrübet nicht mein Herz wenn auf dem falschen Weg
            schreitet. <br />
            Der Herr, Euer Gott ist sehr bleidigt mit so vielen und widerlichn
            Sünden die täglich Begangen werden und einige bereuen nicht einmal
            si gemacht zu haben. <br />
            Aber wegen seiner Güte und unendlichen Barmherzigkeit ist Gott
            geduldig mit Euch. ¡Bekehret Euch bald meine Kinder! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 7. Oktober 1996</h6>
          <p>
            Welch besseren Schmuck gäbe es für die Seele, besonders für die
            Seele in Gnade, als dass ihr mich ehret mitdem Gebet des Heiligen
            Rosenkranzes. Jedesmal wenn ihr dies tuet meine Kinder bin ich sehr
            Nahe von Euch und vermittle vor Gott unserm Herrn für Euch. <br />
            ¡Gelobet sei der Herr! <br />
            Gelobet seien meine Kinder!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10. Oktober 1996</h6>
          <p>
            ¡Meine Kinder beleidigt nicht weiter den Herrn!! Ihr habet nicht
            Teil am Christlichen Leben. <br />
            Dauernd suchet ihr weltliche Freuden, die Euch als fruchtlose
            Christen sein lässt, da ihr in diesen Freuden nicht meinen Sohn
            Jesus finden werdet. Dieses Leben nur auf unnütze Sachen gerichtet
            lässt in Euren Herzen eine entsetzliche Leere, die unmöglich zu
            füllen ist. <br />
            ¡Richtet Eure Blicke wieder auf den Herrn! Der Herr ist Euer und
            wartet auf Eure Bekehrung. <br />
            Gebet Euch dem Herrn und vertraut in ihn. Er ist Eure Festung. Ich
            liebe Euch alle. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12. Oktober 1996</h6>
          <p>
            Es sagt die Allerheiligste Jungfrau: <br />
            Mein Herz bleibt traurig, da viele meiner Kinder fern der
            Barmherzigen Liebe des Herrn sind. <br />
            Obwohl sie andauernd gerufen werden. Diese Kinder haben ihre Ohren
            und Augen verschlossen und nichts gelangt an ihre Verhärterten
            Herzen. Doch die Liebe in meinem Unbeflecktem Herzen, wird bis zum
            Schluss für sie eintreten. <br />
            Betet meine Kinder, der eine für den anderen und für Euch selbst.
            Lobet und segnet den Herrn. Ich liebe Euch alle. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. Oktober 1996</h6>
          <p>
            Predigt immer meine Botschaften, seid gehorsam und lebet in Frieden
            mit allen. Lobet die Göttliche Vorsehung und danket für alle
            Wohltaten. <br />
            Betet und fastet zur <strong> Liebe Jesu </strong> und zu seiner{" "}
            <strong> Allerheiligsten Mutter,</strong>bittet um die dringende
            Bekehrung und den Frieden der Welt. Seid bescheiden und ausdauernd
            beim Gebete um den Frieden der Welt. Habet den festen Vorsatz den
            <strong>Rosenkranz</strong>zu beten in diesen Vorhaben. Wartet nicht
            diese Botschaften mitzuteilen. Ich liebe und segne Euch alle. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 18. Oktober 1996</h6>
          <p>
            Ich bitte um offene, grosszügige Herzen, und so werdet ihr diese
            besondere Gnade verstehen. Die Jesus euer Erlöser Euch schenkt.{" "}
            <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. Oktober 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Heute möchte ich Euch zur Liebe leiten. Ich möchte Euch die Liebe
            die in meinem Unbeflecktem Herzen ist widmen. Und so werden ich Euch
            zum Göttlichn Herzen Jesus führen. Gebet dieser Mutter Eure Herzen,
            und ich bringe Euch zur vollendeten Bekehrung. <br />
            ¡ Gebet Gott Glorie! <br />
            ¡Geehret sei der<strong>Herr</strong>!{" "}
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20. Oktober 1996(morgens)</h6>
          <p>
            Geliebte Kinder: <br />
            Mein Herz ist sehr traurig weil viele Herzen verhärtet und kalt sind
            und so die LIEBE Gottes nicht empfangen können. Nichts rührt diese
            Herzen und sie sind nur für ihre Eigenen Interessen da. <br />
            Sie sind voller Selbsgefälligkeit, begehren alle Ehren der Welt,
            aber sie sind von stei- nerner Frömmigkeit versehen. Wenn sie
            wüssten wie gross mein Leiden für diese Kinder ist die sich selbst
            Weh antun, Weil sie nicht der Liebe des Heiligen Geistes empfänglich
            sind. Höret den Ruf Gottes und<strong>bekehret</strong>Euch
            <strong>ehrlich,</strong>
            jeden Tag, jede Stunde, jede Minute, jede Sekunde die vergeht und so
            wird Euer Vater im Himmel Euch erhören Wenn ihr ihn ruft. <br />{" "}
            ¡Ehre sei dem Herrn! Glorie unserm Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 20 Oktober 1996(nachmittags)</h6>
          <p>
            Betet, betet für all jene die fern der Liebe Gottes sind. Predigt
            und leset meine Botschaften in dem ihr Eure Herzen öffnet. Meditiert
            tief in ihnen. <br />
            Ihr alle seid meine Kinder und ich Möchte Euch zu wirklichen Dienern
            des Herrn machen. <br /> Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21. Oktober</h6>
          <p>
            Meine Kinder. Fliehet vor dem Materialismus, zieht Gottes Sachen vor
            die nüchtern und bescheiden sind. <br />
            Je mehr ihr zu dem Heiligen Geist betet werden Eure Leben
            bescheidener werden. Und der Friede und die Liebe des Herrn wird
            inmitten von Euch leben. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. Oktober 1996</h6>
          <p>
            Meine Kinder: <br />
            ¡ Betet den Heiligen Rosenkranz alle Ta Bittet um die Seelen die am
            fernsten von der Liebe Gottes sind. Es ist Notwendig Tag für Tag zu
            beten um die Seelen zu retten die sich in Sünde befinden. <br />
            Betet für die Kranken und Besorgten und so werdetihr Instrumente der
            Liebe Gottes in der Welt sein. <br />
            An diesem so besonderen Tag schauen viele meiner Kinder mit
            Vertrauen auf mein Mütterliches Herz. Mein Herz hört alle seine
            Kinser diemichlieben und in meine mächtige Fürbitte glauben. <br />
            Weiterhin sage ich Euch. IHR werdet von dem
            <strong>Heiligen Herzen Jesu</strong>erhört beson- ders heute werdet
            ihr getröstet und belebt. Ich, Eure Mutter, bin gekommen um Euch in
            der Liebe Jesu zu stärken. Gehorchet meinem Auftrag und seid fügsam
            zu meine Wünschen, ich verspreche Euch einen radikalen Wechsel in
            Euren Leben. “Folget dem Herrn”. Er ist Gott. Gesegnet seien alle.{" "}
            <br />
            Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. Oktober 1996</h6>
          <p>
            Meine Kinder: <br />
            Das Eure Worte nicht viele seien, sondern wenige aber ehrlich, auf
            dem heiligen Evangelium gestützt, um Gott zu gefallen und den Feind
            zusiegen. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 27. Oktober 1996</h6>
          <p>
            Meine Kinder: <br />
            ¡Ehrer den Herrn! <br />
            Der Herr hat Eure Herzen für diese grosse Äusserung seiner Liebe
            vorbereitet. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5. November 1996</h6>
          <p>
            Euch meine Kinder die schwere Kreuze target sage ich, das ihr
            Hoffnung in den Herrn habet.. Das Euch Eurde Kräfte nicht verlassen
            und nicht die Arme hängen lässt. <br />
            Habet Ausdauer im Gebet zum “Allerheiligsten Eucharistischem Herzen
            Jesus” <br />
            Sehet ihn an und bringet ihm alle Eure Opfer und Traurigkeiten dar.
            So werdet ihr erleichtert und getröstet durch seine LIEBE. <br />
            ¡Glorie sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. November 1996</h6>
          <p>
            Betet meine Kinder für jene die ihr Herz noch verschlossen haben,
            für die Stolzen und jene die mit ihren leeren Leben zufrieden sind.{" "}
            <br />
            ¡Wie viele meiner Kinder sind noch auf dem Wege des Bösen!. <br />
            Betet damit der Herr den Hochmut ihrer Herzen besiege und sie die
            Augen zu ihrem Erlöser wenden. <br />
            Betet und reinigt Eure Gewissen. Verliert keine Zeit. Segnet die
            Zeit in der das LICHT des Herrn bei Euch ist. <br />
            Gebt Gott dank für seine unendliche Liebe. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 7. November 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Ich bete ununterbrochen für Euch, ich vermittle bei der Heiligen
            Dreifaltigkeit damit der Feind nicht Eure Herzen durcheinender
            bringe. Ich bete damit ihr den Herrn kennet und mit Gewissheit die
            wirkliche Anwesenheit Von JESUS CHRISTUS IN DER HEILIGEN EUCHARISTIE
            habet. <br />
            Ich bete damit ihr Eure Leben in Gegeward des Reiches Gottes habt.
            Meine Kinder nichts ist möglich ohne Gott, und alles erhaltet ihr
            durch IHN. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. November 1996</h6>
          <p>
            ¡Gesegnet seid meine Kinder! <br />
            Seid reichlich gesegnet ihr die das Wort des Herrn erhöret und
            folgt. <br />
            Es seien gesegnet die Fammilien die dem Herrn gefallen. <br />
            Es seien gesegnet die die leiden, die Armen und Verlassenen. <br />
            Gesegnet seien die den Namen des Herrn loben.! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 9. November 1996</h6>
          <p>
            Geliebte Kinderlein: <br />
            ¡Besuchet den Herrn! <br />
            Macht dies in Silentium vor dem Allerheiligsten. Er wird Euch
            lehren. <br />
            Bedenked dies. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12. November 1996</h6>
          <p>
            Meine Kinderlein Heute möchte ich Euch bitten jeden Moment des Tages
            zu beten. Als liebevolle Mutter möchte ich Euch auf den Weg der
            Liebe zu Gott leiten der in den Himmel Führt. <br />¡ Öffnet Eure
            Herzen! Ich werde Euch zur Begegnung mit Gott führen. Wenn ihrEuch
            nicht bekehret ist es dass ihr wenig oder garnicht betet. <br />
            Wie unendlich ist die Libe meines Göttlichen Sohnes! Bereit dem
            bereuten Sünder zu vergeben.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 13. November 1996</h6>
          <p>
            Lebet in Ubereinstimmung mit dem Evangelium, machet Gutes und
            verabscheut das Böse. Da alles Gute von Gott herführt und alles Böse
            vom Teufel. Verletzet Euch in keiner Form da der Herr selbst den
            Schmnerz empfängt den ihr Anderen zufügt. <br />
            Der Feindwird versuchen Verstimmungen und Teilungen sähen und wird
            ver- suchen den Hass enzustellen. <br />
            In dieser Forn wird der schlaue Feind unter Euch versteckt sein.
            Deswegen meine gelibeten Kinder bitte ich Euch immer zu beten damit
            ihr die Liebe Gottes unter Euch erkennt und meine Gegenwart als
            liebende Mutter. Ich lade Euch zu einer tiefen Versöhnung mit dem
            Herrn ein, lasst Euch nicht von dem Hochmut verwirren. Betet und
            fastet damit ihr in den Prüfungen gestärkt seid. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 20. November 1996</h6>
          <p>
            Kinder: <br />
            Betet den Heiligen Rosenkranz und ihr seid mit mir vereint. Es ist
            notwendig das Ihr Euch meines Herzens mittels eines einfachen
            Gebetes vereint. <br />
            Ich möchte das ihr folgendes versteht wenn ihr wenig betet bin ich
            wenig bei Euch. Wenn ihr viel betet wird in Eurem Inneren die
            Sehnsuch zur Liebe des Herrn Euren wachsen. <br />
            Es hängt an Euch, ich warte auf Euch meine Kinder. <br />
            Bedenked dies. <br />
            ¡Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26. November 1996</h6>
          <p>
            Ich frage meine Mutter ob si zufrieden ist mit dem “Büchlein” ihrer
            Botschaften... <br />
            Ich zeige es ihr, sie lächelt mit grosser Freude und sagt: <br />
            mein Herz jauchzt vor Freude mit den Engeln des Himmels, wer das
            Büchlein meiner Botschaften Besitzt hat mein Herz, denn ich bin
            beschieden in einem jeden von ihnen. <br />
            Ihr habt Eurem Volk einen Regen von Segnungen herangezogen. <br />
            ¡Gelobet sei der Herr! <br />
            Amen. Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 26 November 1996</h6>
          <p>
            Geliebte Kinder ich möchte gerne mit euch die Freude Meines
            Unbefleckten Herzens teilen, da ihr mich schon kennt und an meiner
            Hand geht. <br />
            Ich möchte an die Herzen gelangen diemichnoch nicht kennen, um ihnen
            eine Neue Hoffnung zu bringen. Sie zum Licht von Jesus Christus zu
            bringen, ich Möchte ihr Leben mit Hoffnung füllen, und ihnen den Weg
            des Guten zeigen. <br />
            Licht in die Dunkelheit bringen, Freud in den Schmerz, Gesundheit in
            der Krankheit.Ich möchte Euch helfen meine Kinder.¡Haltet Euch an
            mein Reines Herz. Ich spreche zu Euch meine Kinder damit ihr beginnt
            mit mir zu beten. Gott erwartet von Euch eine schnelle Bekehrung.{" "}
            <br />
            Ich bin bei Euch, meine Aufgabe als Mutter ist euch auf den Weg zu
            führen der zu Gott geht. <br />
            ¡ Gelobet sei der Herr! <br />
            Amen. Halleluya. Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>(Eine Private Botschaft)…</h6>
          <p>
            …Verbreite weiter meine Verkündigungen besonders die Advokation zum
            ALLER- HEILIGSTEN EUCHARISTISCHEN HERZEN JESU, versuchet das jede
            Seele Sich seinem Herzen weihe und so erhalte sie die unendliche
            Barmherzigkeit Seines Herzens. <br />
            Verbreitet seine Konsagration und sagt das jede Seele die seinem
            Herzen geweiht ist die Gnaden die aus seiner Göttlichen
            Barmherzigkeit fliessen erhal ten werden. <br />
            Diese Weihe dem Alleheiligstem Herzen Jesu, wird einen Stempel der
            Ewigkeit der Seelen haben und einen grossen Wechsel bewirken. Sie
            wird die Seele öffnen für die Bekehrung.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27. November 19996</h6>
          <p>
            Kinder: <br />
            Betet mit inbrünstigen Herzen. Lasset Euch nicht durch die Lauheit
            einfangen. <br />
            “Gott zu lieben ist inniglich zu Ihm zu beten”. <br />
            Ich liebe und segne Euch. <br />
            Amen.Halleluya.Amen.Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28. November 1996</h6>
          <p>
            Geliebte Kinder: <br />
            Heute bitte ich Euch Eure Herzen für<strong>Weihnachten</strong>
            vorzubreiten. <br />
            Als Eure Mutter rate ich Euch dass ihr diese Zeit mit der grössten
            Andacht verbringet. Fastet und haltet Busse mindestens zweimal in
            der Woche, ihr die gute Gesundheit habt. So wenn die Weihnacht kommt
            werdet ihr Friede und Freude haben. <br />
            Machet dies alles in Gottes Namen. <br />
            Ich segne Euch alle. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29. November 1996</h6>
          <p>
            Kinder: <br />
            ¡Bittet den Herrn um die GABE des Glaubens!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 30.November 1996</h6>
          <p>
            Meine Kinder: <br />
            Das alle Eure Gedanken bei Jesus weilen. <br />
            Betet “Jesus” in der Heiligen Kommunion an. Gebet Euch vollkommen
            Ihm hin. <br />
            Amen. Halleluya
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4. Dezember 1996</h6>
          <p>
            Meine Kinder : <br />
            Ich warte noch auf viele Seelen die sich nicht entscheiden. <br />
            ¡Vertrauet mir als Mittlerin! <br />
            Mein Herz ist entzündet in Liebe zu Euch. <br />
            ¡Fürchtet Euch nicht! Nähert Euch mehr und gibt Euch mehr meinem
            Herzen. <br />
            Ich möchte das man michmehr kennt, mehr liebt und mehr verehrt wird
            als Unbefleckte Mutter des Göttlichen Eucharistischen Herezen Jesus.{" "}
            <br />
            Predigt dies.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. Dezember 1996</h6>
          <p>
            ¡ Gelobet sei der Allmächtige ! <br />
            Gesegnet seien die das Wort Gottes erhören. <br />
            Gesegneit seien die mich erhören. <br />
            Gesegnet seien die die kämpfen um die Boshaftigkeit dies Zeit zu
            besiegen. <br />
            Gesegnet seien die die um die Liebe des Namen des Herrnsiegen.{" "}
            <br />
            Meine Kinder betet und liebet das Herz meines Göttlichen Sohnes
            Jesus it all Eurem Wesen. <br />
            Seid gesegnet. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7. Dezember 1996</h6>
          <p>
            Meine Kinderlein: <br />
            Betet zusammen mit meinem Unbeflecktem Herzen. Mein Herz ist die
            Quelle wo ihr nötigen Kräfte sammeln könnt um die schwierigen
            Situationen zu bestreiten. <br />
            Seid gesegnet. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Dezenber 1996</h6>
          <p>
            <strong>¡Gelobet sei der Allmächtige!</strong>
            Meine Kinder: <br />
            Heute möchte ich mit einem jeden von Euch beten, in jedem Herzen
            sein der Michruft um Seelen zu retten die von dem Göttlichen Herzen
            Jesu enfernt sind. <br />
            Ich bin gebenedeit als Unbefleckte Mutter von Jesus. <br />
            Ehre die Allerheiligste Dreifaltigkeit. <br />
            ¡Ehre sei dem Vater! <br />
            ¡ Ehre sei dem Sohn! <br />
            ¡ Ehre dem Heiligen Geiste! <br />
            Amen.Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 11. Dezember 1996</h6>
          <p>
            Meine Kinderlein <br />
            Seid heilig, wie der Herr im Himmel Heilig ist Heiligt Euch in der
            Liebe. Weihet Eure Seelen grosszügig dem Herrn, dem Er über Eure
            Herzen verfügen kann, und ihr die Fülle der Liebe mittels der Weih
            erleben könnt. <br />
            Ich liebe Euch. und segneEuch <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 13. Dezember 1996</h6>
          <p>
            Meine Kinderlein: <br />
            Betet für alle Personen die in Schmerzen leben. Seid treu dem
            Evangelium Von Jesus unser Gott und Erlöser. <br />
            In dieser Zeit der Vorbereitung für Weihnachten, öffnet Eure Herzen,
            sodas Jesus in ihnen geboren werden kann und ihr Botschafter des
            Glaubens seid. <br />
            ¡Gelobet sei der Herr! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14. Dezember 1996</h6>
          <p>
            ¡Gelobet sei mein Göttlicher Sohn! <br />
            Meine Kinderlein heute möchte ich Euch bensonderen Segen zukommen
            lassen und Euch meine grosse Freude des Unbefleckten Herzens
            übermitteln. <br />
            Ich möchte euch besondre Gnaden der Liebe, Frieden und Stärke geben
            damit ihr zur Heiligkeit gelangen könnt. <br />
            Ich wünsche dass Ihr sehr glücklich auf diesem Wege seid und somit
            die Heilige Freude empfindet die von Gott kommt. <br />
            Ich möchte Euch helfen diese Freude zuerlangen. <br />
            Ich warte auf Euch. <br />
            Seid gesegnet. <br />
            Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17. Dezember 1996</h6>
          <p>
            ¡Gelobet sei mein Göttlicher Sohn! <b></b>
            handelt mit Barmherzigkeit geliebte Kinder. Seid geduldsam und
            verständnisvoll mit einander. Dies ist eine Aufgabe jedes Christen.{" "}
            <br />
            Bringet Frieden in Eure Herzen Fliehet vor jeder Teilung und
            Unverständnis das ihr keinen Platz dem Gegener lasst und von ihm
            gebrauch werdet. <br />
            Stützet Euch im Gebet und Euer Geist wird sich dem Guten hinwenden.{" "}
            <br />
            Meine Kinder siegt über das Fleisch und das weltiche jederzeit. Dies
            werdet ihr erlangen, wenn ihr euch mit Jesus in der “Heiligen
            Eucharistie” täglich vereint. <br />
            Amen.Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20. Dezember 1996</h6>
          <p>
            Es sagt die Mutter: <br />
            Gesegnet sei das Jesuskind, gegenwärtig in der “Heiligen
            Eucharistie”
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 22. Dezember 1996</h6>
          <p>
            Meine Kinderlein: <br />
            Bereitet die Krippe in Euren Herzen mit erhlichem Herz vor. <br />
            Seid besheiden und einfach wie Kinder, damit ihr den Erlöser in
            Eurem Herzen empfangen könnt. <br />
            Ehre sei Gott!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>23. Dezember 1996</h6>
          <p>
            Meine geliebten Kinder: das Jesukind ist allen nah. Wenn es mit
            Liebe und ohne Hintergrund empfangen wird. Segnet den Vater im
            Himmel. Ehret das Jesukind welches in der Heiligen Kommunion
            vergegenwärtigt ist. Seid alle gesenget. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. Dezember 1996</h6>
          <p>
            Maria: <br />
            An diesem enmaligen unwiderholbaren Tag in der Geschichte der Welt,
            warteten wir mit Josef, zitternd vor Liebe und Kälte, wir waren sehr
            vereint und in innigem Gebet. Dieses war der Heiligste Moment in der
            Welt als der Sohn Gottes geboren wurde. Vor der Geburt haben Josef
            und ich ihn im Tabernakel meines ubefleckten Leibes, lebende Hostie
            und Göttlich in meinem Wesen angebetet. <br />
            Mit Josef bin ich die este Anbeterin unseres Erlösers. <br />
            Verstehst Du meine Tochter dieses grosse Geschenk des Vaters in
            seiner unend lichen Liebe zur Menschheit? <br />
            Das Göttliche Herz meines Sohnes schlug in meinem Wesen, dann
            öffnete sich der Himmelund der Vater war in der kleinen Krippe
            gegenwärtig um seinen Sohn zu empfangen, dann wurde das kleine
            Göttliche Kind und Mensch in meine Arme und mit Josef meinem Gemahl
            beteten wir es an, in Gegenwart der Allerheiligsten Dreifaltigkeit.{" "}
            <br />
            Nacht der Liebe, des Gebets, der Anbetung und des Friedens. <br />
            Gesegnet seist Du Tochter meines Herzens im Namen des Vaters, des
            Sohnes und Heiligen Geistes.
            <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26.Dezember 1996</h6>
          <p>
            Glorie und Lob der Allerheiligsten Dreifaltigkeit! <br />
            Betet das Kind an, es ist das Licht der Welt! <br />
            Wachet auf Kinderlein, und beginnt das Göttliche Herz des Kindes
            anzubeten. Es ist Gegewärtig in der Heiligen Kommunion. Nähret Euch
            mit diesem Heiligen Brot und er wird euch bekehren. <br />
            Lebt die Kommmunion in Leib und Seele, so werdet ihr lernen zu
            lieben. <br />
            Ich bin die unbefleckte Mutter von Gott und Eure Mutter. Ich bin im
            Herzen meines Göttlichen Sohnes, wer mir vertraut wird zu Gott
            gelangen. <br />
            Seid reichlich gesegnet.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29. Dezember 1996</h6>
          <p>
            Kinder wenn ihr den Himmel verdienen wollt, verzichtet auf Güter die
            ihr in Eurem Herzen sammelt. <br />
            Es befindet sich viel Reichtum in einigen Herzen wenn sie in
            materielle Werte um- gewandelt werden, würde den reichsten der Welt
            verblassen. <br />
            Seid bescheidn<strong>in Euren Herzen,</strong>meine Kinder, sammelt
            keine Schätze,die Euch Nicht im Himmel dienen. Wegen des Gewichts
            werdet ihr nicht hineinkommen. <br />
            Seid wirklich bescheiden! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>30. Dezember 1996</h6>
          <p>
            Kinderlein: <br />
            In dieser Zeit sorget dass der Hochmut und der Neid nich Eure Herzen
            veblinde. <br />
            Achtet aud diesen bösartigen Feind der Seele. <br />
            Gott könnt ihr nicht hintergehen. <br />
            Ehret Gott mit bescheidenem Herzen. <br />
            Ich segne Euch alle. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31. Dezember 1996</h6>
          <p>
            Meine Tochter: <br />
            Bete, lächele und segne alle Deine Brüder. Der Frieden des Herrn sei
            Deine stäte Begleitung. <br />
            Glorie dem Herrn!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Januar 1996</h6>
          <p>
            Ich bin die Mutter Gottes! <br />
            Ich habe meine Augen und mein Herz auf die Kinder der ganzen Welt
            gerichtet. <br />
            Ich bewahre in meinem unbeflecktem Herzen alle meine Kinder die in
            der ganzen Welt zersteut sind. <br />
            Nach Willen des Herrn bleibe ich unter Euch um Euch zu einer
            dringenden Bekehrung zu mahnen. <br />
            Betet meine Kinderlein, betet immer, entfernet Euch nicht vom
            Heiligen Rosenkranz. <br />
            Seid heute gesegnet und es komme über Euch alle meine Kinder in der
            ganzen Welt der Friede, die Liebe und Gottes Segen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8. Januar 1997</h6>
          <p>
            Geliebte Kinder: <br />
            Suchet Zuflucht bei mir ich bin Eure liebende Mutter. <br />
            Suchet keine vorübergehenden Lösungen zu Euren Besorgnissen in dem
            ihr wie die Welt denkt, da ihr Euch mit unnützen Seelischen Ballast
            belastet seid. <br />
            Bedenked ihr seid Kinder Gottes und Diener von Jesus Christus.
            Beschauet sein Göttliches Eucharistisches Herz, bringet ihm all die
            Liebe Eurer Herzen dar, und ihr werdet von Euren Lasten und
            besorgnissen erleichtert. Der Friede und die Freude kommt wieder in
            Euer Leben. Ich liebe Euch inniglich. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10. Januar 1997</h6>
          <p>
            Meine kinder: <br />
            Betet und fasted! <br />
            Erhebet Euer Herz zum Himmel. <br />
            Achtet nicht auf unwichtige Dinge, bittet um Stärke und Ausdauer um
            zu beten. <br />
            Vernachlässigt nicht die Nächstenliebe, seid bewusst desGuten, hütet
            Euch vor dem Teufel der verführerisch und lügnerisch erscheint um
            euch in Versuchung zu bringen, wenn ihr dies erhöhrt wird seine
            macht Euch nicht erreichen. <br />
            Ich bete für Euch alle. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19. Januar 1997</h6>
          <p>
            Meine Kinder: <br />
            Ich warte. Tag für Tag. Kommet zu mir und schützed Euch in meinem
            Unbe- Flecktem Herzen, ich möchte meinen Segen über Euch ausbreiten.{" "}
            <br />
            In Euch wird die Notwendigkeit der LIEBE wachsen, da ihr in einer
            Welt lebet Wo es scheint dass das materielle esenziell wäre um
            glücklichzu sein. <br />
            Ich bin gekommen um Euch im Innern zu bekehren., mit der Wärme
            meiner Mütterlichen Liebe, versteht und liebet das Göttliche Herz
            Jesu.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21. Januar 1996</h6>
          <p>
            Meine Kinderlein: <br />
            Bereitet Euch vor, in dieser Zeit der Bekehrung. Offnet Eurre Herzen
            um Gebet. <br />
            Betet zum Heiligen Geist damit sein Licht und seine Liebe Eure
            Schritte leite. <br />
            Wachet auf! Betet ständig, lasst Euch nich unterkriegen. <br />
            Gelobt sei Jesus Cristus. <br />
            Amen.Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>24. Januar 1996</h6>
          <p>
            Unsere Allerheiligste Mutter und Immwährende Jungfrau Maria sagt:{" "}
            <br />
            Ich möchte über all meine Kinder unendliche Segen ausbreiten, ich
            bitte um andauerndes Gebet, für diese Zeit der Bekehrung. <br />
            Ich bin gekommen um in Euch allen wirkliche Liebe zum Herrn zu
            erwecken. <br />
            Das der Friede und die Liebe des Herrn Euch begleite und sich üuber
            die ganze Welt ausbreite. <br />
            Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. Januar 1997</h6>
          <p>
            Meine Kinder weihet euch meinem Unbeflecktem Herzen. Predigt diese
            WEIHE. <br />
            Reinlichste Mutter mein, ich möchte Dir mein HERZ weihen, mein
            WILLE, mein GANZES LEBEN <br />
            Bringe mich zu deinem Göttlichen Sohn Jesus, damit er in mir wohne.
            Ich möchte vollkommen dein sein Meine Mutter und ab heute Dir treu
            dienen was du von mir verlangst. <br />
            -sei süsse Begleitung in meinem Leben, erlaube nie mich von Dir zu
            trennen, in der Stunde des Todes komme mich holen um in der Ewigkeit
            mich in Deiner Begleitung zu erfreuen. <br />
            Gebenedeit und gelobet seist Du für immer meine Mutter. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31. Januar 1997</h6>
          <p>
            Gelobe sei er Herr! <br />
            Gesegnet seid meine Kinder, ich wünsche inniglich das ihr alle
            zusammen dem Heili- gen Geisete betet, damit die Kraft des Gebetes
            Kriege verhindert, den Hunger die Not sowie die Naturkatastophen.{" "}
            <br />
            Verlasset nicht Euer Christliches Leben, versuchet am Tag Zeit für
            das Gebet zu haben, erinnert diesen meinen Wunsch damit in Euren
            Herzen die Sehnsucht zum Gebet wache betet mit Innigkeit dem
            Allermächtigsten in dieser Mison damit der Teufel nicht weitere
            Seelen an sich reisst. <br />
            Ehre sei Gott! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25. februar 1997</h6>
          <p>
            Ich betete den Heiligen Rosenkranz von dem Bild der Heiligen
            Jungfrau des Rosenkranzes und sah auf ihrer Stirn etwas dunkles, die
            Form eines Kreuzes. <br />
            Nach der Heiligen Kommunion sagte die Mutter Gottes mir: Tochter:{" "}
            <br />
            Das Kreuz auf der Stirn ist ein Zeichen der Bekehrung und Busse um
            die ich Euch Allen meinen Kindern in dieser besonderen Vorosterzeit
            bitte. <br />
            Bereuet Eure Sünden und reinigt Eure Herzen, lasset keine Tege mehr
            vegehen. <br />
            Bereitet Euch vor für den Herrn. <br />
            Er hat Euch gerufen, geht zu seinem Allerheiligsten Herzen. Beleidgt
            ihn nicht mehr. <br />
            In diesem besonderen Tag segne ich Euch mit der unendlichen Liebe
            meines Unbefleckten Herzens. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Juni( Feierlichkeit von Corpus Christi)</h6>
          <p>
            Betend sah ich den Herrn in seiner Herrlichkeit, Glorie und Glanz.{" "}
            <br />
            Er sagte meinen Namen. <br />
            Maria sagte er, schau mich an! Ich sah auf seiner Brust ein
            beindruckendes Herz aus Fleisch, rot, blutend und pochend. Ich
            fühlte eine grossse Wärme als wenn ich in einem Feuer wäre dass mich
            verbrannte. Zur gleichen Zeit fühlte ich eine grosse beatitud
            Frömmigkeit erhob meine Seele zu Ihm. <br />
            Ich nahm Gewahr, Ich weiss nicht wie? Dass der Herr mich in seinem
            Aller- Heiligsten Herzen eingeschlossen hatte, dort fühlte ich das
            perfekte Licht Gottes, das süsse und sanfte seiner Liebe. <br />
            Der Herr sagte: höre achtsam auf dehn Befehl meiner Unendlichen
            Vorsehung. Betet mich an und ehret mich in Wiedergutmachung der
            Beschmähungen, Vergessen und Sakrilege die täglich in der ganzen
            Welt wider das Sakrament meiner Göttlichen<strong>Liebe</strong>
            gemacht werden <br />
            WEIHET EUCH MEINEM ALLERHEILIGSTEM EUCHARISTISCHEM HERZEN UND DEM
            UNBEFLECKEN HERZEN MARIAS, DASS DIE GANZE WELT IHNEN GEWEIHET SEI.{" "}
            <br />
            Es sei bekannt gemacht die“Anbetung dem Allerheiligstem Sakrament,
            als Wirkliche Advokation zu meinem lebendigen Herzen, gegenwärtig in
            der Heiligen Eucharistie“ <br />
            Meine Liebe zu den Seelen is so gross, meine Tochter, das ich die
            Türen des Himmels dem öffnen werde, der mich empfängt und mir
            gehorcht. <br />
            Ich segne Dich meine Tochter mit aller Kraft meiner LIEBE.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6. Juni 1997 (Feierlichkeit des Herzens Jesu)</h6>
          <p>
            Der Herr hat gesagt: <br />
            Seid alle von Mir. Verlasset Euch ganz auf mich! <br />
            Kommet zur Flamme meiner Nächstenliebe.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16. Juli 1997</h6>
          <p>
            Gelobet seien meine Kinder im Allerheiligsten Eucharistischem Herzen
            Jesu! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15. August 1997</h6>
          <p>
            Gelobet sei der Herr! <br />
            An diesem besonderen Tag, segne ich Euch, meine Kinder. <br />
            Ich bin die Mutter von Jesus und Eure Mutter im Himmel. <br />
            Seid klein und bescheiden an diesem Tage und weihet Euch meinem
            Unbe- flecktem Herzen. <br />
            Bekehret Euch dem Herrn meine Kinder. <br />
            Liebet einander mi ehrlichem Herzen, dass die Verzeihung das Licht
            in Euren Herzen sei und so wird der Herr Euch reichlich segnen.{" "}
            <br />
            Verlasset Euch auf die LIEBE des Göttlichen Herzens und betet mit
            sauberen und reinem Herzen . Betet meine Kinder, Betet in diesem
            Sinne. <br />
            Gepriesen und geehret sei das Göttliche Herz. <br />
            Gesegnet seien meine Kinder. <br />
            Amen. Halleluya.Amen. Halleluya.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>29. August 1997</h6>
          <p>
            Gepriesen sei der Herr! <br />
            Wenn die Menschen sich nicht bekehren und den Herrn erhören wird es
            viele Kriege geben und Krankheiten werden die Menschheit foltern,
            sage ihnen dass sie zu Gott zurückkehren, dass sie Sein
            <strong>Wort</strong>erhören, den heiligen Rosenkranz beten. Viele
            Herzen sind sehr verhärtet, viele Ohren bleiben taub für meine
            Botschaften. Ich möchte erhört werden, betet in diesem Sinn. <br />
            ich werde den Herrn um Deine Absichten bitten“. Gesegnet seiest Du
            Tochter meines Herzens. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13. September 1997</h6>
          <p>
            Gelobet sei Jesus Christus! An diesem besonderen Tag zu Ehren der
            <strong>Mutter Gottes,</strong>möchte ich reichen Segen all meinen
            Kindern die leiden und besorgt sind zukommen lassen. Ich möchte sie
            trösten und beleben mit der Liebe meines Unbefleckten Herzens.
            kommet zur Mutter, meine kleinen Kinder un alle werdet in dem Schutz
            meines unbefleckten Herzens Zuflucht finden.in diesen Tagen bitte
            ich Euch mit dem Herzen zu beten, sammelt Euch in der Liebe des
            Göttlichen Herzens Jesus. Betet damit die widerspenstigen Herzen
            weich werden Leset meine Botschaften, lest mit reinem Herzen, sie
            sind ein mächtiges Mittel Euch Zum Allerheiligsten Eucharistischen
            Herzen Jesus zu bringen, wo die Erlösung und Heiligung der Seelen
            ist. Bekehrt Euch in wirkiche Freunde Jesus. Predige dies meine
            Tochter predige dies der ganzen Welt Gesegnet seien meine Kinder!
            Amen. Halleluya. Amen.Halleluya
          </p>
        </div>
      </LayoutMensajesVirgen>
    </>
  );
}
